<template>
  <div>
    <div
      style="
        position: fixed;
        top: 20px;
        z-index: 10;
        backdrop-filter: blur(2px);
      "
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container bluebtn" @click.self="closefiltercard()">
      <div
        class="cf-header d-flex justify-content-between align-items-center"
        @click="closefiltercard()"
      >
        <span>Talent Pool</span>
        <!-- <div v-b-modal.viewfeedbackTP>view feedback</div>
        <div v-b-modal.checkMultipleExcelCand-2 style="background-color: red">
          excel
        </div>
        <div v-b-modal.thirdpartymodal style="background-color: red">
          Thirdparty
        </div> -->
        <div class="d-flex gap-15">
          <b-button
            v-if="roles.includes('BOOKMARK_TALENTPOOL_CANDIDATE')"
            @click="goToBookmark()"
            class="acs-addBtn-modal padding-6-19"
            >View Bookmarks
          </b-button>
          <div
            v-if="!roles.includes('GET_VENDOR_DASHBOARD')"
            class="relativeclass text-nowrap"
            ref="addToggle"
            v-closable="{
              exclude: ['addToggle', 'addToggledropdown'],
              handler: 'hideaddToggle',
            }"
          >
            <b-button
              v-if="roles.includes('PUSH_CANDIDATE')"
              @click="
                (thirdParty = false), (addCandidateToggle = !addCandidateToggle)
              "
              class="acs-addBtn-modal padding-6-19 d-flex align-items-center"
            >
              <img
                src="../../assets/img/accessconnew/whitePlus.svg"
                alt=""
                class="mr-2"
              />
              <span class="">Add Candidate</span>
              <img
                v-if="!addCandidateToggle"
                class="ml-2"
                src="../../assets/img/whitedownarrow.svg"
                alt=""
              />
              <img
                v-else
                class="ml-2"
                src="../../assets/img/whiteuparrow.svg"
                alt=""
              />
            </b-button>
            <div
              v-if="addCandidateToggle"
              class="talentPoolcandidateToggle candidate-z-index"
            >
              <div
                class="pointer unselOption"
                @click="$router.push({ name: 'AddCandidate' })"
              >
                <img
                  class="mr-2"
                  src="../../assets/talentpool/boldPlus.svg"
                  alt=""
                />
                Add New Candidate
              </div>
              <div class="pointer unselOption" @click="openExcelModal">
                <img
                  class="mr-2"
                  src="../../assets/talentpool/mulCand.svg"
                  alt=""
                />
                Add Multiple Candidates
              </div>
              <div
                class="pointer position-relative d-flex justify-content-between"
                v-if="roles.includes('GET_CV_SEARCH') && checkThirdPartyAccess"
                @click="thirdParty = !thirdParty"
                :class="
                  thirdParty
                    ? 'talentpool-thirdparty-sel'
                    : 'talentpool-thirdparty-unsel'
                "
              >
                Add from Third Party
                <img src="../../assets/talentpool/rightArrow.svg" alt="" />
                <div
                  @click.stop="goToCVSearch('talentPool')"
                  class="tp-new-thirdparty-drop"
                  v-if="thirdParty"
                >
                  <div>CV Search</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          style="min-width: 0"
          :class="
            roles.includes('PUSH_CANDIDATE') &&
            roles.includes('PUSH_CANDIDATE_JD')
              ? 'talentPool-table-container relativeclass mt-2'
              : 'tp-table-container mt-2'
          "
        >
          <!-- IF NO DATA IS THERE IN TALENT POOL -->

          <!-- <div class="h-100 w-100 d-flex flex-column align-items-center justify-content-center dashboardAdmin-cards-head">
            <img src="../../assets/talentpool/noDataTalent.svg" alt="">
            <span class="text-center">Initiate your talent pool by selecting the <br> 'Add Candidate' button to add candidates</span>
          </div> -->

          <div class="tp-card-body">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                border-bottom
                pt-2
                pb-2
                pr-3
                pl-3
              "
            >
              <div style="width: 20%" class="tp-black-txt">
                List Of Candidates
              </div>
              <!-- <div
              class="search-bar mr-3 ml-5"
              :style="
                roles.includes('PUSH_CANDIDATE') ? 'width: 60%' : 'width: 85%'
              "
            >
              <img
                class="searchicon"
                src="../../assets/img/search-bar-icon.svg"
                alt=""
              />
              <b-form-input
                class="search-input"
                placeholder="Search Candidates"
                type="search"
                v-model.trim="searchname"
                debounce="500"
                @update="textSearch()"
              ></b-form-input>
            </div> -->

              <div
                class="d-flex align-items-center justify-content-end"
                style="width: 80%"
              >
                <div
                  class="tp-bluetxt mr-4"
                  v-if="
                    roles.includes('PUSH_CANDIDATE_JD') ||
                    roles.includes('DELETE_CANDIDATE')
                  "
                >
                  Selected Candidates: {{ selectedCandidateCount }}
                </div>

                <div class="d-flex align-items-center">
                  <div
                    v-if="roles.includes('REASSIGN_TALENTPOOL_CANDIDATE')"
                    class="mr-3"
                    :class="isEmpty ? '' : 'pointer'"
                    @click="isEmpty ? '' : getReassign()"
                  >
                    <img
                      v-b-popover.hover.top="
                        isEmpty ? 'Select Candidates to reassign' : 'Reassign'
                      "
                      :style="isEmpty ? 'opacity:50%' : ''"
                      src="../../assets/talentpool/Reassign.svg"
                      alt=""
                    />
                  </div>
                  <div
                    v-if="roles.includes('TRIGGER_CVS')"
                    class="mr-3"
                    :class="isEmpty ? '' : 'pointer'"
                    @click="isEmpty ? '' : showTriggerCVS()"
                  >
                    <img
                      v-b-popover.hover.top="
                        isEmpty
                          ? 'Select Candidates to trigger CVS'
                          : 'Trigger CVS'
                      "
                      :style="isEmpty ? 'opacity:50%' : ''"
                      src="../../assets/img/trigger-CVS-icon.svg"
                      alt=""
                    />
                  </div>
                  <!-- Column configuration (show/hide + reorder columns) -->
                  <div class="mr-3 relativeclass">
                    <img
                      class="pointer"
                      v-b-popover.hover.top="
                        showColumnConfig ? '' : 'Configure columns'
                      "
                      src="../../assets/talentpool/tp-columns-config.svg"
                      alt=""
                      @click.stop="toggleColumnConfig()"
                    />
                    <div
                      v-if="showColumnConfig"
                      class="tp-column-config-card"
                      @click.stop=""
                    >
                      <!-- Shown columns (table order, draggable, with the
                           pinned divider) followed by the hidden ones A-Z. -->
                      <div ref="cfgList" class="tp-cfg-list">
                        <!-- force-fallback disables native HTML5 drag so
                             only cfgAutoScroll scrolls the list. -->
                        <draggable
                          v-model="menuItems"
                          tag="div"
                          handle=".tp-cfg-drag, .tp-cfg-divider-row"
                          :animation="150"
                          :force-fallback="true"
                          :scroll-sensitivity="40"
                          :scroll-fn="cfgAutoScroll"
                          @start="cfgDragging = true"
                          @end="cfgDragging = false"
                        >
                          <!-- Animates programmatic reorders (the divider
                               snap-back); disabled while dragging. -->
                          <transition-group
                            tag="div"
                            :name="cfgDragging ? '' : 'tp-cfg-flip'"
                          >
                            <div
                              v-for="item in menuItems"
                              :key="
                                item._divider ? 'tp-sticky-divider' : item.key
                              "
                              class="tp-cfg-item"
                              :class="
                                item._divider
                                  ? [
                                      'tp-cfg-divider-row d-flex align-items-center',
                                      { 'tp-cfg-shake': pinDividerShake },
                                    ]
                                  : 'tp-cfg-row d-flex align-items-center justify-content-between'
                              "
                            >
                              <!-- Draggable divider: columns above it are pinned to
                               the left. The whole row is the drag handle (see the
                               `handle` selector on <draggable>), so grabbing the
                               line or the label drags it up/down to change how
                               many columns are pinned. -->
                              <template v-if="item._divider">
                                <span class="tp-cfg-divider-line"></span>
                                <span class="tp-cfg-divider-label"
                                  >Pinned left</span
                                >
                              </template>
                              <template v-else>
                                <div
                                  class="
                                    d-flex
                                    align-items-center
                                    text-truncate
                                    tp-cfg-left
                                  "
                                >
                                  <img
                                    src="../../assets/talentpool/tp-drag-indicator.svg"
                                    class="tp-cfg-drag pointer mr-2"
                                    alt=""
                                  />
                                  <span class="tp-cfg-label text-truncate">{{
                                    item.label
                                  }}</span>
                                </div>
                                <!-- Locked default columns are always shown: the
                                 toggle is disabled, but they can be reordered. -->
                                <img
                                  v-if="item.locked"
                                  class="tp-cfg-toggle tp-cfg-toggle-locked"
                                  src="../../assets/talentpool/tp-toggle-on.svg"
                                  alt=""
                                  v-b-tooltip.hover.top="'Default column'"
                                />
                                <img
                                  v-else-if="item.visible"
                                  class="pointer tp-cfg-toggle"
                                  src="../../assets/talentpool/tp-toggle-on.svg"
                                  alt=""
                                  @click="setColVisible(item, false)"
                                />
                                <img
                                  v-else
                                  class="pointer tp-cfg-toggle"
                                  src="../../assets/talentpool/tp-toggle-off.svg"
                                  alt=""
                                  @click="setColVisible(item, true)"
                                />
                              </template>
                            </div>
                          </transition-group>
                        </draggable>
                        <template v-if="hiddenMenuCols.length">
                          <div class="tp-cfg-section-label">
                            Available columns
                          </div>
                          <div
                            v-for="item in hiddenMenuCols"
                            :key="item.key"
                            class="
                              tp-cfg-item tp-cfg-row
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            <span class="tp-cfg-label text-truncate">{{
                              item.label
                            }}</span>
                            <img
                              class="pointer tp-cfg-toggle"
                              src="../../assets/talentpool/tp-toggle-off.svg"
                              alt=""
                              @click="setColVisible(item, true)"
                            />
                          </div>
                        </template>
                      </div>
                      <div class="tp-cfg-footer">
                        <span
                          class="tp-cfg-reset pointer"
                          @click="resetConfigCols()"
                          >Reset to default</span
                        >
                      </div>
                    </div>
                  </div>
                  <!-- Filtering is unified into the header advanced-search
                       popover; this in-page filter panel is retired (the trigger
                       is removed so it never renders). -->
                  <div
                    v-if="false"
                    class="
                      d-flex
                      align-items-center
                      switchtext
                      pointer
                      relativeclass
                    "
                  >
                    <div ref="closeCard" v-if="showfiltercard">
                      <div
                        class="tp-panelist-filtercard d-flex align-items-center"
                      >
                        <div class="w-100">
                          <div class="filter-inner" style="max-height: 215px">
                            <!-- 1. Skills -->
                            <b-row>
                              <b-col>
                                <div
                                  class="topDiv aoeskl-field panellist-tags"
                                  @click.stop=""
                                >
                                  <label class="acs-input-head"
                                    >Skills &nbsp;</label
                                  >
                                  <b-form-tags
                                    class="text-truncate filter-input-pan w-100"
                                    id="input-1"
                                    placeholder="Enter Skills"
                                    v-model="filterObject.skillSets"
                                    type="text"
                                    invalid-tag-text="Duplicate tag(s)"
                                    remove-on-delete
                                  ></b-form-tags>
                                  <!-- :tag-validator="tagValidatorskill" -->
                                </div>
                                <div class="hint-txt ml-3">
                                  Press "Enter" to add skills
                                </div>
                              </b-col>
                            </b-row>

                            <!-- 2. CVS Status -->
                            <b-row>
                              <b-col>
                                <div class="topDiv mt-3">
                                  <label class="acs-input-head"
                                    >CVS Status</label
                                  >
                                  <Select
                                    :type="'filter'"
                                    :dropdownOptions="cvsStatusFilterOpt"
                                    :showError="false"
                                    :disableDropdown="false"
                                    :value="filterObject.cvsStatus"
                                    :placeholder="'Select CVS Status'"
                                    @setValue="filterObject.cvsStatus = $event"
                                  />
                                </div>
                              </b-col>
                            </b-row>

                            <!-- 3. Source -->
                            <b-row>
                              <b-col>
                                <div class="mt-3">
                                  <Sourcemulti
                                    :from="'scroll-filter'"
                                    :label="'Source'"
                                    :placeholder="'Select Source'"
                                    :vmodel="filterObject.filterSource"
                                    :hideVendor="
                                      roles.includes('GET_VENDOR_DASHBOARD')
                                    "
                                    :showThirdParty="
                                      !roles.includes('GET_VENDOR_DASHBOARD') &&
                                      checkThirdPartyAccess
                                    "
                                    @setValue="
                                      filterObject.filterSource = $event
                                    "
                                  />
                                </div>
                              </b-col>
                            </b-row>

                            <!-- 4. Accessible By (filter is backed by createdBy = added by) -->
                            <div
                              class="previewfdbck-tabs mt-2"
                              v-if="!roles.includes('GET_VENDOR_DASHBOARD')"
                            >
                              <b-row>
                                <b-col>
                                  <AddedByUsers
                                    :from="'scroll-filter'"
                                    :placeholder="'Select'"
                                    :label="'Added By'"
                                    :vmodel="filterObject.createdByUserName"
                                    @setValue="
                                      filterObject.createdByUserName = $event
                                    "
                                  />
                                </b-col>
                              </b-row>
                            </div>

                            <!-- 5. Updated At -->
                            <b-row>
                              <b-col>
                                <div @click.stop="" class="topDiv mt-3">
                                  <DateField
                                    format="YYYY-MM-DD"
                                    type="daterange"
                                    :vmodel="filterObject.selectedUpdatedDate"
                                    :label="'Updated At'"
                                    placeholder="Select date range"
                                    id="updated-date-filter-range"
                                    from="talentpool-filter"
                                    :range="true"
                                    @select-value="
                                      filterObject.selectedUpdatedDate = $event
                                    "
                                  />
                                </div>
                              </b-col>
                            </b-row>

                            <!-- 6. Created At -->
                            <b-row>
                              <b-col>
                                <div @click.stop="" class="topDiv mt-3">
                                  <DateField
                                    format="YYYY-MM-DD"
                                    type="daterange"
                                    :vmodel="filterObject.selectedDate"
                                    :label="'Created At'"
                                    placeholder="Select date range"
                                    id="date-filter-range"
                                    from="talentpool-filter"
                                    :range="true"
                                    @select-value="
                                      filterObject.selectedDate = $event
                                    "
                                  />
                                </div>
                              </b-col>
                            </b-row>

                            <!-- 7. Status (formerly "Type") -->
                            <b-row>
                              <b-col>
                                <div class="topDiv mt-3">
                                  <label class="acs-input-head">Status</label>
                                  <Select
                                    :type="'filter'"
                                    :dropdownOptions="filterTypeOpt"
                                    :showError="false"
                                    :disableDropdown="false"
                                    :value="filterObject.filterType"
                                    :placeholder="'Select Status'"
                                    @setValue="filterObject.filterType = $event"
                                  />
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                          <div class="d-flex justify-content-between bluebtn">
                            <b-button
                              class="acs-cancelBtn-filter mt-3"
                              @click="cancelFilter()"
                            >
                              Cancel
                            </b-button>
                            <div class="mt-3 d-flex">
                              <b-button
                                class="acs-cancelBtn-filter mr-2"
                                :disabled="disableApplyFilter"
                                @click="
                                  disableApplyFilter && filtercount == 0
                                    ? ''
                                    : filtercount == 0
                                    ? clearfilter(false)
                                    : clearfilter(true)
                                "
                              >
                                Reset
                              </b-button>
                              <b-button
                                :disabled="
                                  disableApplyFilter && filtercount == 0
                                "
                                class="acs-cancelBtn-filter"
                                @click="applyTalentFilterTest()"
                              >
                                Apply
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="roles.includes('BOOKMARK_TALENTPOOL_CANDIDATE')"
                    class="mr-3"
                  >
                    <img
                      v-b-popover.hover.top="
                        isEmpty ? 'Select Candidates to bookmark' : 'Bookmark'
                      "
                      :style="isEmpty ? 'opacity:50%' : ''"
                      @click="!isEmpty ? showAddBookmark() : ''"
                      :class="!isEmpty && 'pointer'"
                      src="../../assets/img/bookmarks/bookmarkicon.svg"
                      alt=""
                    />
                  </div>
                  <template v-if="showFilterDel">
                    <div
                      v-if="roles.includes('DELETE_CANDIDATE')"
                      class="d-flex switchtext mr-3"
                      @click="isEmpty ? '' : calldeletemodal()"
                      :disabled="isEmpty"
                    >
                      <img
                        v-if="isEmpty"
                        v-b-popover.hover.top="'Select Candidates to delete'"
                        src="../../assets/talentpool/disDelete.svg"
                        alt=""
                        class="defaultCursor"
                      />
                      <img
                        v-else
                        v-b-popover.hover.top="'Delete'"
                        src="../../assets/talentpool/Delete.svg"
                        class="pointer"
                        alt=""
                      />
                    </div>
                  </template>
                </div>
                <div class="d-flex justify-content-end relativeclass">
                  <div id="disAddJob">
                    <b-popover
                      v-if="isEmpty"
                      target="disAddJob"
                      triggers="hover"
                      placement="top"
                    >
                      <span>Select Candidates to add to job</span>
                    </b-popover>
                    <b-button
                      v-if="
                        roles.includes('PUSH_CANDIDATE_JD') &&
                        !roles.includes('GET_VENDOR_DASHBOARD')
                      "
                      class="
                        acs-addBtn-modal
                        padding-6-19
                        disjdbtn
                        d-flex
                        align-items-center
                        mr-3
                      "
                      :disabled="isEmpty"
                      @click="openAddToJob()"
                    >
                      <img
                        src="../../assets/img/accessconnew/whitePlus.svg"
                        alt=""
                        class="mr-2"
                      />
                      <span class="">Add To Job</span>
                    </b-button>
                  </div>
                  <div
                    v-if="
                      roles.includes('SEND_JOB_OPPURTUNITY') &&
                      !roles.includes('GET_VENDOR_DASHBOARD')
                    "
                    id="disSendJob"
                  >
                    <b-popover
                      v-if="isEmpty"
                      target="disSendJob"
                      triggers="hover"
                      placement="top"
                    >
                      <span>Select Candidates to send job opportunity</span>
                    </b-popover>
                    <b-button
                      class="
                        acs-addBtn-modal
                        padding-6-19
                        disjdbtn
                        d-flex
                        align-items-center
                        mr-3
                      "
                      :disabled="isEmpty"
                      @click="openJobOppurtunity()"
                    >
                      <img
                        src="../../assets/img/accessconnew/whitePlus.svg"
                        alt=""
                        class="mr-2"
                      />
                      <span class="">Send Job Opportunity</span>
                    </b-button>
                  </div>
                  <div v-if="allCandidateDetails.length !== 0">
                    <b-button
                      @click="showexportcard = !showexportcard"
                      class="acs-addBtn-modal padding-6-19"
                      >Export Excel
                    </b-button>
                  </div>
                </div>

                <!-- modal -->
                <div>
                  <b-modal
                    id="addVendModal"
                    no-close-on-backdrop
                    size="lg"
                    centered
                    hide-header
                    hide-footer
                    @hidden="clearvendDetails()"
                  >
                    <span class="tp-card">Assigned Candidates to JD'sss</span>
                    <div
                      @click="
                        roles.includes('GET_VENDOR_DASHBOARD')
                          ? clearvendDetails()
                          : ''
                      "
                      class="xMarkCancel"
                    >
                      <img src="../../assets/xmark.svg" alt="" />
                    </div>

                    <hr />
                    <div>
                      <b-row>
                        <b-col cols="6">
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            <div class="tp-card">JD Details</div>
                            <div class="tp-below-text">
                              Total JD's :
                              <span class="tp-card">{{
                                addjddata.length
                              }}</span>
                            </div>
                          </div>
                          <div class="tp-modal-card">
                            <!-- //parent div -->
                            <div
                              class="tp-sub-card mt-3"
                              v-for="(data, index) in addjddata"
                              :key="index"
                              @click="addtojddetails(data)"
                              :class="
                                particularCandidateDetails == data
                                  ? 'tp-sub-card-first '
                                  : 'tp-sub-card'
                              "
                            >
                              <!-- card design -->
                              <div
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                "
                              >
                                <div
                                  class="tp-below-text text-truncate"
                                  style="width: 50%"
                                  v-b-popover.hover.bottom="data.jobName"
                                >
                                  {{ data.jobName }}
                                </div>
                                <div class="tp-text">
                                  {{ data.successCount + data.failedCount }}
                                  Candidates
                                </div>
                              </div>
                              <div
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                  mt-4
                                  tp-text
                                "
                              >
                                <div class="tp-green-text">
                                  Success :
                                  <span style="font-weight: 600">{{
                                    data.successCount
                                  }}</span>
                                </div>
                                <div class="tp-red-text">
                                  Failure :
                                  <span style="font-weight: 600">{{
                                    data.failedCount
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex align-item-center">
                            <div>
                              <img
                                src="../../assets/img/talentpool/alerticon.svg"
                                alt=""
                              />
                            </div>
                            <div class="ml-2 tp-modal-note">
                              You can view all candidates who have been added to
                              JDs, and if the candidates have already been added
                              to the JD, they will not be added again
                            </div>
                          </div>
                        </b-col>

                        <b-col cols="6">
                          <div class="tp-second-right-overflow">
                            <div
                              class="
                                d-flex
                                align-items-center
                                justify-content-between
                              "
                            >
                              <div class="tp-card">Candidates Details</div>
                              <div class="tp-below-text">
                                Total Candidates:
                                <span class="tp-card">{{
                                  candidateSelected.length
                                }}</span>
                              </div>
                            </div>
                            <div
                              v-if="
                                particularCandidateDetails.failed.length > 0
                              "
                            >
                              <div class="tp-side-modal-card-1 mt-3">
                                <div class="tp-top-existcard"></div>

                                <div class="p-2">
                                  <div class="tp-card-head">
                                    Existing Candidates
                                  </div>
                                  <div class="tp-text-1 mt-1">
                                    These Candidates have already been added to
                                    this
                                  </div>

                                  <div class="tp-side-modal-below-card mt-2">
                                    <div
                                      class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                        p-2
                                        tp-below-text
                                      "
                                      v-for="(
                                        i, index
                                      ) in particularCandidateDetails.failed"
                                      :key="index"
                                    >
                                      <div
                                        class="text-truncate"
                                        style="width: 50%"
                                      >
                                        <div
                                          class="ellipsis tp-below-text"
                                          v-b-tooltip.hover.top="i.name"
                                        >
                                          {{ i.name }}
                                        </div>
                                      </div>
                                      <div
                                        class="text-truncate"
                                        style="width: 50%"
                                      >
                                        <div
                                          class="ellipsis tp-text-1"
                                          v-b-tooltip.hover.top="i.email"
                                        >
                                          {{ i.email }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="
                                particularCandidateDetails.success.length > 0
                              "
                            >
                              <div class="tp-side-modal-card-1 mt-3">
                                <div class="tp-top-card"></div>
                                <div class="p-2">
                                  <div class="tp-card-head">
                                    Newly added Candidates
                                  </div>

                                  <div class="tp-side-modal-below-card mt-1">
                                    <div
                                      class="
                                        d-flex
                                        p-2
                                        align-items-center
                                        justify-content-between
                                        tp-below-text
                                      "
                                      v-for="(
                                        i, index
                                      ) in particularCandidateDetails.success"
                                      :key="index"
                                    >
                                      <div
                                        class="text-truncate"
                                        style="width: 50%"
                                      >
                                        <div
                                          class="ellipsis tp-below-text"
                                          v-b-tooltip.hover.top="i.name"
                                        >
                                          {{ i.name }}
                                        </div>
                                      </div>
                                      <div
                                        class="text-truncate"
                                        style="width: 50%"
                                      >
                                        <div
                                          class="ellipsis tp-text-1"
                                          v-b-tooltip.hover.top="i.email"
                                        >
                                          {{ i.email }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>

                    <div class="d-flex justify-content-end mt-2">
                      <b-button
                        class="addbtn"
                        style="width: 100px"
                        @click="
                          roles.includes('GET_VENDOR_DASHBOARD')
                            ? clearvendDetails()
                            : ''
                        "
                        >Ok</b-button
                      >
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- talent pool new table design starts from here -->
            <div
              ref="tableScroll"
              class="mt-3 pr-0 pl-0 py-0"
              :class="
                roles.includes('PUSH_CANDIDATE') &&
                roles.includes('PUSH_CANDIDATE_JD')
                  ? 'talentPool-main-table'
                  : 'talentPool-admin-main-table'
              "
            >
              <div
                v-if="allCandidateDetails.length !== 0"
                class="mx-3"
                :class="
                  roles.includes('PUSH_CANDIDATE') &&
                  roles.includes('PUSH_CANDIDATE_JD')
                    ? 'talentPool-table-head'
                    : 'talentPool-admin-table-head'
                "
              >
                <div
                  v-if="
                    allCandidateDetails.length != 0 &&
                    (roles.includes('PUSH_CANDIDATE_JD') ||
                      roles.includes('DELETE_CANDIDATE'))
                  "
                  class="
                    text-center
                    newtp-checkbox
                    tp-no-divider tp-sticky-lead
                  "
                  :style="{ width: '50px', left: checkboxStickyLeft + 'px' }"
                >
                  <b-form-checkbox
                    v-model="allSelected"
                    @change="selectAll()"
                  ></b-form-checkbox>
                </div>
                <div
                  v-if="
                    allCandidateDetails.length == 0 ||
                    (allCandidateDetails.length == 0 && searchQuery != '')
                  "
                  class="tp-no-divider tp-sticky-lead"
                  :style="{ width: '50px', left: checkboxStickyLeft + 'px' }"
                ></div>
                <div
                  class="tp-no-divider tp-sticky-lead"
                  :class="
                    roles.includes('PUSH_CANDIDATE_JD') ||
                    roles.includes('DELETE_CANDIDATE')
                      ? ''
                      : 'pl-3'
                  "
                  :style="{
                    width: '80px',
                    paddingLeft: roles.includes('PUT_CANDIDATE')
                      ? null
                      : '20px',
                    left: sourceStickyLeft + 'px',
                  }"
                >
                  <span class="mr-2">Source</span>

                  <template v-if="statusValue == 'source' && filter">
                    <img
                      v-if="sortByValue && filter"
                      class="pointer"
                      @click="applySortColumn('source', false)"
                      src="../../assets/img/accessconnew/ascSort.svg"
                      alt=""
                    />
                    <img
                      v-if="!sortByValue && filter"
                      class="pointer"
                      @click="clearSort()"
                      src="../../assets/img/accessconnew/descSort.svg"
                      alt=""
                    />
                  </template>
                  <img
                    class="pointer"
                    v-else
                    @click="applySortColumn('source', true)"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt=""
                  />
                </div>
                <!-- Name/Email/Phone/Skills and the configurable columns all
                     render from the ordered model: reorder them from the config
                     popover; drag a column's right-edge divider to resize it. -->
                <div
                  v-for="(col, idx) in orderedVisibleCols"
                  :key="col.key"
                  class="tp-config-col-head d-flex align-items-center"
                  :class="{
                    'tp-sticky-col': idx < effectiveStickyCount,
                    'tp-sticky-col-last': idx === effectiveStickyCount - 1,
                  }"
                  :style="[
                    { width: col.width + 'px' },
                    idx < effectiveStickyCount
                      ? { left: stickyLeftOffsets[idx] + 'px' }
                      : {},
                  ]"
                >
                  <span class="mr-2 text-truncate">{{ col.label }}</span>
                  <!-- Every column except CVS Status is sortable; the backend
                       sorts by the mapped field with a type hint (see buildSortBy).
                       The default order (Updated At, newest first) shows as an
                       active desc arrow on Updated At; that column toggles
                       desc <-> asc, since clearing it is the default. Other
                       columns show arrows only once a sort is applied (`filter`). -->
                  <template
                    v-if="
                      col.sortable !== false &&
                      statusValue == col.key &&
                      (filter || col.key === 'updatedAt')
                    "
                  >
                    <img
                      v-if="sortByValue"
                      class="pointer"
                      @click.stop="
                        col.key === 'updatedAt'
                          ? clearSort()
                          : applySortColumn(col.key, false)
                      "
                      src="../../assets/img/accessconnew/ascSort.svg"
                      alt=""
                    />
                    <img
                      v-else
                      class="pointer"
                      @click.stop="
                        col.key === 'updatedAt'
                          ? applySortColumn(col.key, true)
                          : clearSort()
                      "
                      src="../../assets/img/accessconnew/descSort.svg"
                      alt=""
                    />
                  </template>
                  <img
                    v-else-if="col.sortable !== false"
                    class="pointer"
                    @click.stop="applySortColumn(col.key, true)"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt=""
                  />
                  <!-- No resizer on the last column: it sits against the pinned
                       Actions column, whose boundary is a fixed divider. -->
                  <span
                    v-if="idx !== orderedVisibleCols.length - 1"
                    class="tp-col-resizer"
                    @mousedown.stop.prevent="startResize($event, col)"
                  ></span>
                </div>
                <div
                  class="text-center tp-actions-col"
                  :style="
                    roles.includes('PUT_CANDIDATE')
                      ? 'width: 80px'
                      : 'width: 80px'
                  "
                >
                  <span>Actions</span>
                </div>
              </div>
              <div
                class="px-3"
                :class="
                  roles.includes('PUSH_CANDIDATE') &&
                  roles.includes('PUSH_CANDIDATE_JD')
                    ? 'talentPool-table-body'
                    : 'talentPool-admin-table-body'
                "
                id="top1"
              >
                <template v-if="allCandidateDetails.length === 0">
                  <div
                    v-if="
                      allCandidateDetails.length === 0 &&
                      searchQuery === '' &&
                      filtercount == 0 &&
                      advancedFilters.length === 0 &&
                      !LoaderStatus
                    "
                    class="
                      tp-empty-state
                      d-flex
                      justify-content-center
                      align-items-center
                      flex-column
                    "
                  >
                    <div>
                      <img
                        v-if="roles.includes('GET_VENDOR_DASHBOARD')"
                        src="../../assets/img/talentpool/ven-talentpool-nodata.svg"
                        alt=""
                      />
                      <img
                        v-else
                        src="../../assets/img/talentpool/talentpool-nodata.svg"
                        alt=""
                      />
                    </div>
                    <div
                      class="search-text-no-data text-center"
                      v-if="roles.includes('GET_VENDOR_DASHBOARD')"
                    >
                      Currently, there are no candidates added to <br />the
                      talent pool
                    </div>
                    <div class="search-text-no-data text-center" v-else>
                      Initiate your talent pool by selecting the <br />'Add
                      Candidate' button to add candidates
                    </div>
                  </div>
                  <div
                    v-else-if="
                      (allCandidateDetails.length === 0 &&
                        searchQuery !== '' &&
                        filtercount == 0) ||
                      (advancedFilters.length != 0 &&
                        allCandidateDetails.length === 0)
                    "
                    class="
                      tp-empty-state
                      d-flex
                      justify-content-center
                      align-items-center
                      flex-column
                    "
                  >
                    <div>
                      <img
                        src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                        alt=""
                      />
                    </div>
                    <div class="search-text-no-data text-center">
                      No candidates match your search filters.<br />Try
                      adjusting or clearing them to see more results.
                    </div>
                    <button
                      type="button"
                      class="tp-clear-filters"
                      @click="clearAllFilters"
                    >
                      Clear filters
                    </button>
                  </div>
                  <div
                    v-else-if="filtercount != 0"
                    class="
                      tp-empty-state
                      d-flex
                      flex-column
                      justify-content-center
                      align-items-center
                    "
                  >
                    <div>
                      <img
                        src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                        alt=""
                      />
                    </div>
                    <div class="mt-2 text-center access-font-color">
                      No candidates match your search filters.<br />Try
                      adjusting or clearing them to see more results.
                    </div>
                    <button
                      type="button"
                      class="tp-clear-filters"
                      @click="clearAllFilters"
                    >
                      Clear filters
                    </button>
                  </div>
                </template>
                <template v-else>
                  <div
                    v-for="(i, index) in allCandidateDetails"
                    :key="index"
                    class="talentPool-table-row"
                    style="cursor: pointer"
                    @click="openCandidatePreview(i)"
                  >
                    <div class="tp-gridgreencolorDynamic"></div>
                    <div
                      :style="{
                        width: '50px',
                        left: checkboxStickyLeft + 'px',
                      }"
                      class="text-center relativeclass tp-sticky-lead"
                      v-if="
                        roles.includes('PUSH_CANDIDATE_JD') ||
                        roles.includes('DELETE_CANDIDATE')
                      "
                      @click.stop
                    >
                      <div class="newtp-checkbox">
                        <b-form-checkbox
                          name="checkbox-2"
                          :disabled="!i.active"
                          :value="i.candidateID"
                          v-model="candidateSelected"
                          @change="deselect(), (assignedCandidate = i)"
                        >
                        </b-form-checkbox>
                      </div>
                    </div>
                    <div
                      class="relativeclass tp-sticky-lead"
                      :style="{
                        width: '80px',
                        paddingLeft: roles.includes('PUT_CANDIDATE')
                          ? '15px'
                          : '20px',
                        left: sourceStickyLeft + 'px',
                      }"
                    >
                      <img
                        v-if="convertToLowerCase(i.source) == 'linkedin'"
                        src="../../assets/img/talentpool/linkdin.svg"
                        alt=""
                      />
                      <img
                        v-else-if="convertToLowerCase(i.source) == 'monster'"
                        src="../../assets/img/talentpool/monster.svg"
                        alt=""
                      />
                      <img
                        v-else-if="convertToLowerCase(i.source) == 'naukri'"
                        src="../../assets/img/talentpool/naukri.svg"
                        alt=""
                      />
                      <img
                        v-else-if="convertToLowerCase(i.source) == 'indeed'"
                        src="../../assets/img/talentpool/indeed.svg"
                        alt=""
                      />

                      <img
                        v-else-if="convertToLowerCase(i.source) == 'vendor'"
                        src="../../assets/vendor-new-icon.svg"
                        alt=""
                      />
                      <img
                        v-else-if="convertToLowerCase(i.source) == 'seek'"
                        src="../../assets/img/talentpool/seek.svg"
                        alt=""
                      />
                      <img
                        v-else
                        src="../../assets/img/talentpool/default.svg"
                        alt=""
                      />
                    </div>
                    <!-- <div
                      class="ellipsis pr-3"
                      style="width: 14.8%"
                      v-if="!roles.includes('GET_VENDOR_DASHBOARD')"
                    >
                      <div class="ellipsis">
                        <span v-b-tooltip.hover.top="i.createdByUserName">{{
                          i.createdByUserName
                        }}</span>
                      </div>
                    </div> -->
                    <div
                      v-for="(col, idx) in orderedVisibleCols"
                      :key="col.key"
                      class="tp-config-col-body"
                      :class="{
                        'tp-sticky-col': idx < effectiveStickyCount,
                        'tp-sticky-col-last': idx === effectiveStickyCount - 1,
                      }"
                      :style="[
                        { width: col.width + 'px' },
                        idx < effectiveStickyCount
                          ? { left: stickyLeftOffsets[idx] + 'px' }
                          : {},
                      ]"
                    >
                      <template v-if="col.key === 'name'">
                        <div
                          class="ellipsis"
                          style="min-width: auto; max-width: 85%"
                        >
                          <span v-b-tooltip.hover.top="i.name">{{
                            i.name
                          }}</span>
                        </div>
                      </template>
                      <template v-else-if="col.key === 'email'">
                        <span
                          v-b-tooltip.hover.top="i.email"
                          class="d-inline-block text-truncate"
                          style="min-width: auto; max-width: 100%"
                          >{{ i.email }}</span
                        >
                      </template>
                      <template v-else-if="col.key === 'phone'">
                        {{ i.phoneNumber }}
                      </template>
                      <template v-else-if="col.key === 'skills'">
                        <div
                          :id="'jo' + i.candidateID"
                          style="width: fit-content; max-width: 100%"
                          class="text-truncate"
                        >
                          {{ i.skills.join(", ") }}
                        </div>
                        <b-tooltip
                          :target="'jo' + i.candidateID"
                          triggers="hover"
                          placement="top"
                        >
                          {{ i.skills.join(", ") }}
                        </b-tooltip>
                      </template>
                      <template v-else-if="col.key === 'accessibleBy'">
                        <template v-if="i.userIcons.length == 1">
                          <div
                            class="w-100 pt-2"
                            v-for="(icon, iconIndex) in i.userIcons"
                            :key="iconIndex"
                          >
                            <span
                              class="text-truncate d-inline-block"
                              style="min-width: auto; max-width: 80%"
                            >
                              {{ icon.name }}
                            </span>
                          </div>
                        </template>
                        <div
                          v-else
                          class="
                            d-flex
                            align-items-center
                            position-relative
                            tp-access-icons
                          "
                        >
                          <div
                            v-for="(icon, iconIndex) in i.userIcons &&
                            i.userIcons.slice(0, 3)"
                            :key="iconIndex"
                            class="roundDarkBlue"
                            :style="{ left: `${iconIndex * 25}px` }"
                            v-b-tooltip.hover.top="icon.name"
                          >
                            {{ icon.initials }}
                          </div>
                          <div
                            class="roundLightBlue"
                            v-if="i.userIcons && i.userIcons.length > 3"
                            :style="{ left: '75px' }"
                            v-b-tooltip.hover.top="
                              getRemainingNamesTooltip(i.userIcons)
                            "
                          >
                            +{{ i.userIcons && i.userIcons.length - 3 }}
                          </div>
                        </div>
                      </template>
                      <template v-else-if="col.key === 'cvsStatus'">
                        <span
                          class="tp-cvs-status"
                          :style="{ color: cvsStatusColor(i.cvsStatus) }"
                          >{{ cvsStatusLabel(i.cvsStatus) }}</span
                        >
                      </template>
                      <template v-else-if="col.key === 'status'">
                        <span
                          :style="{ color: i.active ? '#038E00' : '#E70016' }"
                          >{{ i.active ? "Active" : "Inactive" }}</span
                        >
                      </template>
                      <template v-else>
                        <span
                          class="d-inline-block text-truncate"
                          style="max-width: 100%"
                          v-b-tooltip.hover.top="colText(i, col)"
                          >{{ colText(i, col) }}</span
                        >
                      </template>
                    </div>
                    <div
                      class="text-center relativeclass tp-actions-col"
                      :class="{
                        'tp-actions-col-open': openKebabId === i.candidateID,
                      }"
                      :style="
                        roles.includes('PUT_CANDIDATE')
                          ? 'width: 80px'
                          : 'width: 80px'
                      "
                      @click.stop
                    >
                      <img
                        class="pointer kanban-image-hover"
                        src="../../assets/img/newkanban/more.svg"
                        alt=""
                        @click.stop="toggleKebab(i.candidateID)"
                      />
                      <div
                        class="kanban-more-option-card"
                        v-if="openKebabId === i.candidateID"
                      >
                        <div
                          v-if="!roles.includes('GET_VENDOR_DASHBOARD')"
                          class="
                            kanban-more-option-card-input
                            d-flex
                            align-items-center
                          "
                          @click="
                            setTagData(i), addNote(i), (openKebabId = null)
                          "
                        >
                          <img
                            src="../../assets/new-icons/comment-dots-plus.svg"
                            class="mr-2"
                            alt=""
                          />
                          Add Note
                        </div>

                        <div
                          v-if="
                            roles.includes('PUT_CANDIDATE') &&
                            i.isEditable &&
                            i.active
                          "
                          class="
                            kanban-more-option-card-input
                            d-flex
                            align-items-center
                          "
                          @click="editCandidate(i), (openKebabId = null)"
                        >
                          <img
                            src="../../assets/talentpool/edit.svg"
                            class="mr-2"
                            alt=""
                          />
                          Edit
                        </div>
                        <div
                          v-else-if="
                            roles.includes('PUT_CANDIDATE') && !i.active
                          "
                          class="
                            kanban-more-option-card-input
                            d-flex
                            align-items-center
                          "
                          @click="
                            i.isEditable == false &&
                            roles.includes('GET_VENDOR_DASHBOARD')
                              ? activateModal(i)
                              : activateCand(i),
                              (openKebabId = null)
                          "
                        >
                          <img
                            src="../../assets/talentpool/disableEdit.svg"
                            class="mr-2"
                            alt=""
                          />
                          Activate
                        </div>
                        <div
                          v-else-if="
                            roles.includes('PUT_CANDIDATE') && !i.isEditable
                          "
                          class="
                            kanban-more-option-card-input
                            d-flex
                            align-items-center
                            disable-icon
                          "
                          v-b-tooltip.hover.left="
                            i.active
                              ? 'You don\'t have permission to edit this candidate'
                              : 'Once a candidate is pushed into any JD, editing is not allowed'
                          "
                        >
                          <img
                            src="../../assets/talentpool/edit.svg"
                            class="mr-2"
                            alt=""
                          />
                          Edit
                        </div>

                        <div
                          v-if="i.resume"
                          class="
                            kanban-more-option-card-input
                            d-flex
                            align-items-center
                          "
                          @click="exportResume(i), (openKebabId = null)"
                        >
                          <img
                            src="../../assets/talentpool/download.svg"
                            class="mr-2"
                            alt=""
                          />
                          Download Resume
                        </div>
                        <div
                          v-else
                          class="
                            kanban-more-option-card-input
                            d-flex
                            align-items-center
                            disable-icon
                          "
                        >
                          <img
                            src="../../assets/talentpool/disabledownload.svg"
                            class="mr-2"
                            alt=""
                          />
                          Download Resume
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <div
              class="
                d-flex
                justify-content-between
                align-items-center
                acs-paginaTion-new
                mx-3
                tp-pagination-bar
              "
            >
              <div class="d-flex">
                <span class="acs-gotopage-text p-1">Go to page</span>
                <b-form-input
                  type="text"
                  class="acs-pagination-num mr-1"
                  v-model="goToPage"
                  @keyup.enter="goToPages()"
                  @keypress="NumbersOnly"
                  @paste="handlePaste"
                ></b-form-input>
                <b-button
                  class="acs-pagination-addbtn"
                  @click="goToPages"
                  :class="
                    (goToPage === null ||
                      goToPage == '' ||
                      !iscontainsNumber) &&
                    'disabled-pagination-arrow'
                  "
                  :disabled="
                    goToPage === null || goToPage == '' || !iscontainsNumber
                  "
                >
                  <span
                    ><img
                      src="../../assets/img/accessconnew/blueRight.svg"
                      alt=""
                  /></span>
                </b-button>
              </div>
              <div class="pagination">
                <b-pagination
                  v-model="currentPage"
                  @input="goToPagination()"
                  :total-rows="total"
                  :per-page="pageCount"
                  align="center"
                  first-number
                  last-number
                >
                  <template #prev-text
                    ><span
                      ><img
                        src="../../assets/img/accessconnew/pageleft.svg"
                        alt=""
                      /> </span
                  ></template>
                  <template #next-text
                    ><span
                      ><img
                        src="../../assets/img/accessconnew/pageright.svg"
                        alt="" /></span
                  ></template>
                </b-pagination>
              </div>
              <div class="d-flex align-items-center">
                <PageInput :pagecount="pageCount" @update-value="updatePage" />
                <div
                  class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end"
                >
                  Results : <span v-if="pageStart > total">0</span
                  ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                  <span class="pl-1"></span> of <span class="pr-1"></span
                  >{{ total }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modals starts from here -->

    <!-- modal view particular candidates -->
    <PreviewCandidateSidebar
      v-if="viewCandidateModal"
      :showModal="viewCandidateModal"
      :selectedCandidate="selectedCandidate"
      :candidateID="selectedCandidate.candidateID"
      :customFieldsArray="customFieldsArray"
      :showNote="true"
      :showActivate="true"
      @close-view-icon="closeViewIcon"
      @add-note="(noteTagData = $event), addNote(selectedCandidate)"
      @retrigger-cvs="showTriggerCVS([$event])"
    />

    <!-- this is adding multiple candidates excel -->
    <AddMultipleExcelModal
      :context="this"
      @update-talent-pool="getTalentPoolCandidateRedis()"
      :addMultipleCandidates="addMultipleCandidates"
      v-if="addMultipleCandidates"
      @input="handleAddCandidates"
      :checkMultiple="checkMultiple"
      @closeExcel="handleCloseMultple"
      @closeAddedMultipleExcelCand="handleAdd"
    />

    <!-- AddtoJDModal recruiter -->
    <AddtoJDModal
      :showJobOppurtunity="showJobOppurtunity"
      v-if="showAddToJd"
      :showModal="showAddToJd"
      :candidateSelected="candidateSelected"
      :from="'talentpool'"
      @close-modal="closeAddToJdModal"
      @candidates-selected="handleCandidatesSelected"
    />
    <!-- Reassign Modal -->
    <Reassign
      v-if="isReassign"
      :showModal="isReassign"
      @close-modal="closeAssignRec"
      :candidateSelected="candidateSelected"
      @update-method="getTalentPoolCandidateRedis"
      @handle-reset="resetValues"
      :selectedCandidate="assignedCandidate"
    />
    <!-- Trigger CVS Modal (Talent Pool) -->
    <TriggerCVSModal
      v-if="showCvsTriggerModal"
      :showModal="showCvsTriggerModal"
      :roles="roles"
      :selectedCandidates="selectedCandidatesForCVS"
      :successDetails="cvsSuccessDetails"
      :submitting="cvsSubmitting"
      @trigger-cvs="triggerCVSFromTalentPool"
      @remove-candidate="removeCvsCandidate"
      @close-modal="closeTriggerCVS"
    />
    <AddNote
      v-if="showAddNote"
      :showAddNote="showAddNote"
      :viewCandidateModal="viewCandidateModal ? false : true"
      @close-modal="closeAddNote"
      :candidateID="addNoteId"
      :noteTagData="
        !roles.includes('GET_VENDOR_DASHBOARD') ? noteTagData : null
      "
      @update-talentpool="getTalentPoolCandidateRedis()"
      :showAttachment="true"
    />
    <b-modal
      id="activatemodal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="$bvModal.hide('activatemodal')"
    >
      <div class="d-flex">
        <div class="mr-3">
          <img
            v-b-popover.hover.top="'Close'"
            src="../../assets/toast/success.svg"
            alt=""
          />
        </div>
        <div class="w-100">
          <div class="d-flex align-items-center justify-content-between">
            <div class="acs-modal-content pr-3 mt-1">
              Are you sure you want to activate the candidate
              {{ selectedActivate.name }}?
            </div>
            <div @click="$bvModal.hide('activatemodal')">
              <img
                class="rotate-on-hover"
                src="../../assets/img/accessconnew/blueCross.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button
          class="acs-cancelBtn-modal mr-3"
          @click="$bvModal.hide('activatemodal')"
          >Cancel</b-button
        >
        <b-button class="acs-addBtn-modal" @click="activateCandidate()"
          >Continue</b-button
        >
      </div>
    </b-modal>
    <b-modal
      id="modaldelete"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="$bvModal.hide('modaldelete')"
    >
      <div class="d-flex">
        <div class="mr-3">
          <img
            v-b-popover.hover.top="'Close'"
            src="../../assets/New-imgs/teams-icons/teams-delete-main-icon.svg"
            alt=""
          />
        </div>
        <div class="w-100">
          <div class="d-flex justify-content-between">
            <div class="acs-modal-head">Delete Candidate</div>
            <div @click="$bvModal.hide('modaldelete')">
              <img
                class="rotate-on-hover"
                src="../../assets/img/accessconnew/blueCross.svg"
                alt=""
              />
            </div>
          </div>
          <div class="acs-modal-content pr-3 mt-1">
            Are you sure you want to delete
            {{
              selectedCandidateCount == 1
                ? "this Candidate"
                : "selected Candidates"
            }}
            from Talent Pool?
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button
          class="acs-cancelBtn-modal mr-3"
          @click="$bvModal.hide('modaldelete')"
          >Cancel</b-button
        >
        <b-button
          class="acs-addBtn-modal"
          @click="deleteParticularCandidate(false)"
          >Delete</b-button
        >
      </div>
    </b-modal>

    <!-- delete confirm modal for vendor -->
    <b-modal
      id="deleteconfirmvendor"
      centered
      hide-footer
      hide-header
      @hidden="$bvModal.hide('deleteconfirmvendor')"
    >
      <div class="d-flex">
        <div class="mr-3">
          <img
            v-b-popover.hover.top="'Close'"
            src="../../assets/New-imgs/teams-icons/teams-delete-main-icon.svg"
            alt=""
          />
        </div>
        <div class="w-100">
          <div class="d-flex justify-content-between">
            <div class="acs-modal-head">Delete Candidate</div>
            <div @click="$bvModal.hide('deleteconfirmvendor')">
              <img
                class="rotate-on-hover"
                src="../../assets/img/accessconnew/blueCross.svg"
                alt=""
              />
            </div>
          </div>
          <div class="acs-modal-content pr-3 mt-1">
            Are you sure you want to delete
            {{
              selectedCandidateCount == 1
                ? "this Candidate"
                : "selected Candidates"
            }}
            from Talent Pool?
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button
          class="acs-cancelBtn-modal mr-3"
          @click="$bvModal.hide('deleteconfirmvendor')"
          >Cancel</b-button
        >
        <b-button
          class="acs-addBtn-modal"
          @click="deleteParticularCandidate(true)"
          >Delete</b-button
        >
      </div>
    </b-modal>
    <!-- delete confirm modal for vendor end -->

    <!-- jd modal for vendor -->
    <b-modal
      id="addjdmodal-2"
      centered
      hide-footer
      hide-header
      size="lg"
      no-close-on-backdrop
      @hidden="$bvModal.hide('addjdmodal-2'), clearaddvendmodal()"
    >
      <b-overlay :show="showLoader" rounded="sm">
        <div
          class="tp-card d-flex align-items-center justify-content-between mb-3"
        >
          Add Candidate(s) to JD(s)
        </div>
        <div
          v-if="!showLoader"
          @click="$bvModal.hide('addjdmodal-2'), clearaddvendmodal()"
          class="xMarkCancel"
          style="top: -26px; right: -26px"
        >
          <img src="../../assets/xmark.svg" alt="" />
        </div>
        <hr />
        <div class="tp-modal-overflow">
          <b-row>
            <b-col :cols="vendColsCount">
              <div>
                <div class="tp-card mb-2">My Assigned JD's</div>
                <div class="search-bar" style="width: 100%">
                  <img
                    class="searchicon"
                    src="../../assets/img/search-bar-icon.svg"
                    alt=""
                  />
                  <b-form-input
                    class="search-input"
                    placeholder="Search JD's"
                    type="search"
                    v-model.trim="searchVend"
                    @input="vendSearch()"
                  ></b-form-input>
                </div>
                <div
                  style="height: 500px"
                  v-if="
                    vendorDetails.length == undefined ||
                    vendorDetails.length == 0
                  "
                  class="
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-center
                    tp-cust-name-overflow
                  "
                >
                  <img src="../../assets/img/nofoldersearch.svg" alt="" />
                  <div class="mt-3 ml-3 wb-nocard-selected-font text-break">
                    No JD's found for "{{ searchVend }}"
                  </div>
                </div>

                <div
                  class="tp-cust-name-overflow mt-1"
                  v-else
                  @scroll="scrollVendors"
                >
                  <div
                    v-for="(i, index) in vendorDetails"
                    :key="index"
                    class="
                      tp-cust-back-white tp-grey-checkbox
                      d-flex
                      text-truncate
                      align-items-center
                      mt-2
                      mb-2
                      mr-1
                      ml-1
                    "
                  >
                    <div class="pt-2">
                      <b-form-checkbox
                        name="checkbox-2"
                        :value="i"
                        v-model="selectVend"
                      >
                      </b-form-checkbox>
                    </div>
                    <span class="tp-card-head pt-2">{{ i.title }}</span>
                  </div>
                  <div
                    style="margin: auto"
                    v-if="vendLoader"
                    class="d-flex justify-content-center mt-3 mb-1"
                  >
                    <b-spinner small label="Loading..."></b-spinner>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col
              cols="6"
              :style="
                vendorDetails && vendorDetails.length === 0 && searchVend !== ''
                  ? 'display: none;'
                  : ''
              "
            >
              <div>
                <div class="tp-height-vendor pt-4">
                  <!--*************    UNCOMMENT WHEN NO DATA IS THERE    ***************-->
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-center
                      h-100
                    "
                    v-if="selectVend.length == 0"
                  >
                    <img src="../../assets/novendselected.svg" alt="" />
                  </div>
                  <div v-else class="tp-side-modal-card-vendor mt-1 mr-1 ml-1">
                    <div class="tp-top-card"></div>
                    <div class="p-2">
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <div class="tp-card-head">Selected JD(s)</div>
                        <div class="tp-card-head pr-1">
                          {{ selectVend.length }}
                        </div>
                      </div>

                      <div
                        class="
                          tp-side-modal-below-card-vendor tp-below-text
                          mt-1
                        "
                      >
                        <div
                          v-for="(i, index) in selectVend"
                          :key="index"
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                            p-1
                          "
                        >
                          <div style="width: 80%" class="text-truncate">
                            {{ i.title }}
                          </div>
                          <div @click="removevend(index)" class="pointer">
                            <img
                              v-b-popover.hover="'Remove JD'"
                              src="../../assets/talentpool/cancelround.svg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-end mt-4">
                  <b-button
                    :disabled="selectVend.length == 0"
                    class="addbtn pl-4 pr-4"
                    @click="addvendcand()"
                    >Next</b-button
                  >
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-modal>

    <b-modal
      id="showexportmodal"
      v-model="showexportcard"
      size="md"
      centered
      hide-footer
      hide-header
      @hidden="clearexport()"
    >
      <div>
        <div class="cs-modal-header">
          <div>Export Excel</div>
          <div @click="clearexport()">
            <img
              class="rotate-on-hover"
              src="../../assets/img/accessconnew/blueCross.svg"
              alt=""
            />
          </div>
        </div>

        <div class="mt-3 cs-modal-body-2">
          <div class="d-flex talentpool-dates">
            <div class="position-relative w-50 mr-3">
              <DateField
                :type="'date'"
                :label="'From Date'"
                :mandatory="false"
                :placeholder="'Select'"
                :id="'from-date'"
                @select-value="updateFieldValue('startDate', $event)"
                :format="'DD-MM-YYYY'"
              />
            </div>
            <div class="position-relative w-50">
              <DateField
                :type="'date'"
                :label="'To Date'"
                :mandatory="false"
                :placeholder="'Select'"
                :id="'to-date-special'"
                @select-value="updateFieldValue('endDate', $event)"
                :format="'DD-MM-YYYY'"
                :startDate="exportExcel.startDate"
              />
            </div>
          </div>
          <div class="d-flex talentpool-dates mt-3">
            <div class="position-relative w-50 mr-3">
              <DateField
                :type="'time'"
                :label="'Start Time'"
                :mandatory="false"
                :placeholder="'Select'"
                :id="'start-time'"
                @select-value="updateFieldValue('startTime', $event)"
                :format="hourFormat"
              />
            </div>
            <div class="position-relative w-50">
              <DateField
                :type="'time'"
                :label="'End Time'"
                :mandatory="false"
                :placeholder="'Select'"
                :id="'end-time'"
                @select-value="updateFieldValue('endTime', $event)"
                :format="hourFormat"
                :startTime="exportExcel.startTime"
              />
            </div>
          </div>
          <div class="position-relative mt-3 panellist-tags" @click.stop="">
            <div class="acs-input-head">Skills</div>
            <b-form-tags
              v-model="exportExcel.skillSets"
              input-id="tags-basic"
              style="min-height: 36px; max-height: 67px; overflow-y: auto"
              class="text-truncate d-flex w-100"
              placeholder="Enter skills"
              remove-on-delete
            ></b-form-tags>
            <div class="cf-light-txt-2 mt-1">Press "Enter" to add skills</div>
          </div>
          <div class="position-relative mt-3">
            <Sourcemulti
              :label="'Source'"
              :placeholder="'Select Source'"
              :vmodel="exportExcel.source"
              :showThirdParty="false"
              @setValue="updateFieldValue('source', $event)"
            />
          </div>
          <div
            class="position-relative mt-3"
            v-if="!roles.includes('GET_VENDOR_DASHBOARD')"
          >
            <AddedByUsers
              :label="'Added By'"
              :placeholder="'Select'"
              :vmodel="exportExcel.addedBy"
              @setValue="updateFieldValue('addedBy', $event)"
            />
          </div>
          <div class="mt-3 teams-filter-head">Candidate Status :</div>

          <div class="mt-2 allocateradios d-flex align-items-center w-100 mb-4">
            <b-form-group
              :class="index == 0 ? 'ml-0' : 'ml-3'"
              v-for="(i, index) in exporttypeoptions"
              :key="i.value"
            >
              <b-form-radio v-model="exportExcel.type" :value="i.value"
                >{{ i.text }}
              </b-form-radio>
            </b-form-group>
          </div>
        </div>
        <div
          class="
            d-flex
            align-items-center
            justify-content-end
            border-top
            pt-2
            pb-3
            pr-4
            bluebtn
          "
        >
          <b-button
            :class="
              startDate == '' &&
              endDate == '' &&
              skills.length == 0 &&
              exporttypeselected == ''
                ? 'disabled-text'
                : 'pointer'
            "
            @click="clearexport()"
            class="acs-cancelBtn-modal mr-3 mt-1"
            >Cancel</b-button
          >
          <div class="relativeclass">
            <b-button
              @click="exportcandidate()"
              :class="
                exportLoader ? 'export-loader-class defaultCursor' : 'pointer'
              "
              class="acs-addBtn-modal mt-1"
              ><span v-if="!exportLoader">Export</span></b-button
            >
            <div v-if="exportLoader" class="export-loader-pos">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="thirdpartymodal"
      size="md"
      centered
      hide-footer
      hide-header
      @hidden="clearexport()"
    >
      <div>
        <div class="cs-modal-header">
          <div>Redirect to Third Party (Bamboo HR)</div>
          <div>
            <img
              class="rotate-on-hover"
              src="../../assets/img/accessconnew/blueCross.svg"
              alt=""
            />
          </div>
        </div>

        <div
          class="
            mt-3
            cs-modal-body-3
            d-flex
            flex-column
            align-items-center
            justify-content-center
          "
        >
          <img src="../../assets/talentpool/thirdpartyModal.svg" alt="" />
          <span class="text-center pff-modal-heading"
            >You will be redirected to external website
            <span class="blue-italic-txt">“Bamboo HR”</span>.<br />
            Click on “Continue” to proceed</span
          >
        </div>
        <div
          class="
            d-flex
            align-items-center
            justify-content-end
            border-top
            pt-2
            pb-3
            pr-4
            bluebtn
          "
        >
          <b-button
            :class="
              startDate == '' &&
              endDate == '' &&
              skills.length == 0 &&
              exporttypeselected == ''
                ? 'disabled-text'
                : 'pointer'
            "
            @click="clearexport()"
            class="acs-cancelBtn-modal mr-3 mt-1"
            >Cancel</b-button
          >
          <b-button @click="exportcandidate()" class="acs-addBtn-modal mt-1"
            >Export</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      id="bookmarkcandidate"
      centered
      hide-footer
      hide-header
      @hidden="closeBookmark()"
    >
      <div>
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="b-modal-header" v-if="!showcreateFolder">
            Bookmark {{ selCount }} Candidate{{ selCount != 1 ? "s" : "" }}
          </div>
          <div class="b-modal-header" v-else>
            <img
              src="../../assets/img/bookmarks/bckarw.svg"
              class="pointer mr-2"
              @click="showcreateFolder = false"
              alt=""
            />
            Create New Folder
          </div>
          <div class="rotate-on-hover pointer" @click="closeBookmark()">
            <img src="@/assets/img/accessconnew/blueCross.svg" alt />
          </div>
        </div>
        <hr class="my-0" />

        <div class="p-3">
          <section
            v-if="!showcreateFolder && folders.length == 0"
            style="padding: 0px 8px 0px 8px"
          >
            <div
              v-if="folders.length == 0"
              class="
                bookmark-blue-container
                fs-14
                fw-600
                font-lato
                color-455B6C
              "
            >
              Please click on
              <span class="color-mainblue"> “Create New Folder”</span> to add
              the selected candidates to your bookmarks.
            </div>
            <div class="mt-3 fs-14 fw-600 font-lato color-595959">
              ADD TO FOLDER:
            </div>

            <div
              class="
                fs-16
                fw-500
                color-mainblue
                font-mont
                d-flex
                align-items-center
                mt-3
              "
            >
              <img
                @click="showcreateFolder = true"
                src="../../assets/img/bookmarks/createfolder.svg"
                class="mr-3 pointer"
                alt=""
              />
              <span class="pointer" @click="showcreateFolder = true"
                >Create New Folder</span
              >
            </div>
          </section>
          <section v-else-if="showcreateFolder" class="mt-2 mb-3 px-2">
            <Input
              placeholder="Enter"
              label="Folder Name"
              type="text"
              id="bookmark"
              @handle-enter="bookmarkLoader ? '' : addFolder()"
              :vmodel="$v.folderName.$model"
              @select-value="$v.folderName.$model = $event"
              :showError="$v.folderName.$error"
            />
            <div class="errortxt" v-if="$v.folderName.$error">
              {{
                !$v.folderName.required
                  ? "Required"
                  : "Max char length exceeded"
              }}
            </div>
          </section>
          <section v-if="!showcreateFolder && folders.length != 0">
            <div style="padding: 0px 8px 0px 8px">
              <div class="mt-3 fs-14 fw-600 font-lato color-595959">
                ADD TO FOLDER:
              </div>

              <div
                class="
                  fs-16
                  fw-500
                  color-mainblue
                  font-mont
                  d-flex
                  align-items-center
                  mt-3
                "
              >
                <img
                  @click="showcreateFolder = true"
                  src="../../assets/img/bookmarks/createfolder.svg"
                  class="mr-3 pointer"
                  alt=""
                />
                <span class="pointer" @click="showcreateFolder = true"
                  >Create New Folder</span
                >
              </div>
            </div>
            <section class="bookmark-folder-content-height">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  mt-4
                  w-100
                "
                v-for="folder in folders"
                :key="folder.folderID"
              >
                <div class="d-flex align-items-center w-90">
                  <img
                    v-if="selectedFolders.includes(folder.folderID)"
                    class="mr-3"
                    src="../../assets/img/bookmarks/selectedfolder.svg"
                    alt=""
                  />
                  <img
                    v-else
                    class="mr-3"
                    src="../../assets/img/bookmarks/unselectedfolder.svg"
                    alt=""
                  />
                  <div class="w-85">
                    <h6
                      :class="
                        selectedFolders.includes(folder.folderID)
                          ? 'color-mainblue fw-600'
                          : 'color-3a3c40 fw-500'
                      "
                      class="fs-16 font-mont mb-1 text-truncate"
                    >
                      {{ folder.folderName }}
                    </h6>
                    <div class="fw-500 fs-14 color-8c8c8c">
                      {{ folder.usersCount }} Candidate{{
                        folder.usersCount != 1 ? "s" : ""
                      }}
                    </div>
                  </div>
                </div>

                <img
                  class="pointer"
                  @click="selFolder('remove', folder)"
                  v-if="selectedFolders.includes(folder.folderID)"
                  src="../../assets/img/bookmarks/tickcheck.svg"
                  alt=""
                />
                <img
                  class="pointer"
                  @click="selFolder('add', folder)"
                  v-else
                  src="../../assets/img/bookmarks/unchecked.svg"
                  alt=""
                />
              </div>
            </section>
          </section>
        </div>
        <hr class="my-0" />

        <div class="p-3 w-100 d-flex align-items-center justify-content-end">
          <div class="bluebtn d-flex align-items-center">
            <b-button
              class="acs-cancelBtn-modal mr-3"
              @click="
                showcreateFolder
                  ? ((showcreateFolder = false),
                    (folderName = null),
                    $v.$reset())
                  : closeBookmark()
              "
              >Cancel</b-button
            >
            <div class="position-relative">
              <b-button
                :class="
                  bookmarkLoader
                    ? 'confirm-loader-class defaultCursor'
                    : 'pointer'
                "
                class="acs-addBtn-modal pl-4 pr-4"
                :disabled="!showcreateFolder && selectedFolders.length == 0"
                @click="
                  bookmarkLoader
                    ? ''
                    : showcreateFolder
                    ? addFolder()
                    : bookmarkCands()
                "
                >{{
                  bookmarkLoader ? "" : showcreateFolder ? "Create" : "Confirm"
                }}</b-button
              >
              <div v-if="bookmarkLoader" class="confirm-loader-pos">
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AddNote from "../../components/Kanban/modal/AddNoteModal.vue";
import toast from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import AddMultipleExcelModal from "../../controllers/vendorCode/modals/AddMultipleExcelModal.vue";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import AddtoJDModal from "../../controllers/Talentpool/AddtoJDModal.vue";
import PageInput from "../../components/InputComponents/PaginationInput.vue";
import EventBus from "../../utils/eventBus.js";
import { downloadResumeFile } from "../../utils/download.js";
import DateField from "../../components/InputComponents/DateField.vue";
import Reassign from "../../components/Kanban/modal/Reassign.vue";
import draggable from "vuedraggable";
import TriggerCVSModal from "../../controllers/Talentpool/TriggerCVSModal.vue";
import {
  addtojd,
  getTalentPoolCandidateRedis,
  getVendorJd,
  getResume,
  deleteCandidate,
  getCustomerFields,
  putCandidate,
  uploadDocumentAPI,
  addFolder,
  getBookmarkFolders,
  addFolderUser,
  trigerCvs,
} from "../../utils/apiFunctions";
import Select from "../../components/fixedcomponents/Select.vue";
import AddedByUsers from "../../components/fixedcomponents/TalentPool/AddedByUsers.vue";
import Loader from "../../components/fixedcomponents/Loader.vue";
import Sourcemulti from "../../components/fixedcomponents/TalentPool/Source.vue";
import commonFunc from "../../components/mixin/commonFunctions.js";
import PreviewCandidateSidebar from "../../controllers/JD/modals/PreviewCandidateSidebar.vue";
import { formatYearsDate } from "../../controllers/commonHelpers";
import { fieldDisplayLabel } from "@/utils/customFields";
import Input from "@/components/InputComponents/Input.vue";
import { maxLength, required } from "vuelidate/lib/validators";

// Pristine default set of configurable columns (used on load and by "Reset to default").
// The leading "locked" columns (Name/Email/Phone/Skills) are always visible - their
// toggle is disabled in the config popover - but they can be reordered like any other.
function defaultTalentPoolCols() {
  return [
    {
      key: "name",
      label: "Candidate Name",
      visible: true,
      width: 190,
      type: "fixed",
      locked: true,
      sortable: true,
    },
    {
      key: "email",
      label: "Email ID",
      visible: true,
      width: 220,
      type: "fixed",
      locked: true,
      sortable: true,
    },
    {
      key: "phone",
      label: "Phone Number",
      visible: true,
      width: 140,
      type: "fixed",
      locked: true,
    },
    {
      key: "skills",
      label: "Skills",
      visible: true,
      width: 170,
      type: "fixed",
      locked: true,
    },
    {
      key: "accessibleBy",
      label: "Accessible By",
      visible: true,
      width: 150,
      type: "builtin",
      vendorHidden: true,
    },
    {
      key: "updatedAt",
      label: "Updated At",
      visible: true,
      width: 130,
      type: "builtin",
      sortable: true,
    },
    {
      key: "cvsStatus",
      label: "CVS Status",
      visible: true,
      width: 130,
      type: "builtin",
      // Sorting by CVS status is too slow on large talent pools; filter instead.
      sortable: false,
      // Vendors can't trigger CVS.
      vendorHidden: true,
    },
    {
      key: "status",
      label: "Status",
      visible: true,
      width: 110,
      type: "builtin",
    },
    {
      key: "experience",
      label: "Experience",
      visible: false,
      width: 120,
      type: "builtin",
    },
    {
      key: "addedBy",
      label: "Added By",
      visible: false,
      width: 150,
      type: "builtin",
      vendorHidden: true,
    },
    {
      key: "createdAt",
      label: "Created At",
      visible: false,
      width: 130,
      type: "builtin",
    },
  ];
}

export default {
  name: "TalentPool",

  components: {
    Spinner,
    AddNote,
    AddMultipleExcelModal,
    AddtoJDModal,
    PageInput,
    Select,
    DateField,
    Loader,
    AddedByUsers,
    Sourcemulti,
    Reassign,
    PreviewCandidateSidebar,
    TriggerCVSModal,
    Input,
    draggable,
  },
  mixins: [toast, commonFunc],
  data() {
    return {
      showcreateFolder: false,
      showJobOppurtunity: false,
      isReassign: false,
      addNoteId: "",
      showAddNote: false,
      filterApplied: false,
      showexportcard: false,
      viewCandidateModal: false,
      showCandTPModal: false,
      showAddToJd: false,
      thirdParty: false,
      bookmarkLoader: false,
      // NUMBERS
      page: 0,
      type: 1,
      total: 0,
      currentPage: 1,
      filtercount: 0,
      pageCount: 10,
      goToPage: null,
      timer: null,
      vendCount: 14,
      vendtotalData: null,
      vendPageEnd: null,
      folderName: null,

      // BOOLEAN
      addMultipleCandidates: false,
      addedByDropdown: false,
      checkMultiple: false,
      applyflag: false,
      sortByValue: false,
      LoaderStatus: false,
      dbfilterdrop: false,
      showfiltercard: false,
      addCandidateToggle: false,
      allSelected: false,
      filter: false,
      showLoader: true,
      jdLoader: false,
      vendLoader: false,
      showSpinner: false,
      exportLoader: false,
      // STRINGS
      status: "",
      endDate: "",
      selectJob: "",
      startDate: "",
      searchVend: "",
      addData: "",
      pageEnd: "",
      sourceof: "",
      pageStart: "",
      searchname: "",
      downloadlink: "",
      searchAddedBy: "",
      sortOrder: "-1",
      statusType: "1",
      sortColumn: "updatedAt",
      statusValue: "updatedAt",
      hourFormat: "HH:mm",
      exporttypeselected: "2",
      storeSourceof: "",
      searchexcelsheets: "",
      storeFilterSource: [],
      assignedCandidate: {},
      noteTagData: {},
      storeFilterType: "",

      // ARRAYS
      folders: [],
      selectedFolders: [],
      customFieldsArray: [],
      storeFilterSkills: [],
      storeFilterAddedBY: [],
      storeFilterDate: [],
      storeFilterUpdatedDate: [],
      storeFilterCvs: "",
      allcustomerDetails: [],
      areaofexp: [],
      vendorDetails: [],
      selectVend: [],
      jobData: [],
      jobVend: [],
      skills: [],
      addjddata: [],
      area: [],
      allCandidateDetails: [],
      body: [],
      jdName: [],
      selectedCandidate: [],
      deleteCandidate: [],
      candidateSelected: [],
      jobSelected: [],
      advancedFilters: [],
      exporttypeoptions: [
        { text: "All", value: "2" },
        { text: "Active Candidates", value: "1" },
        { text: "Inactive Candidates", value: "0" },
      ],
      thirdPartyDropdown: [
        {
          value: "cvSearch",
          text: "CV Search",
        },
      ],
      source_options: [
        {
          value: "naukri",
          text: "Naukri",
        },
        {
          value: "monster",
          text: "Monster",
        },
        {
          value: "indeed",
          text: "Indeed",
        },
        {
          value: "linkedin",
          text: "Linkedin",
        },
        {
          value: "vendor",
          text: "Vendor",
        },
        {
          value: "other",
          text: "Others",
        },
        // {
        //   value: "thirdparty",
        //   text: "Third Party",
        // },
      ],
      filterTypeOpt: [
        {
          value: "2",
          text: "All",
        },
        {
          value: "1",
          text: "Active",
        },
        {
          value: "0",
          text: "Inactive",
        },
      ],
      // Mirrors the workbench CVS status options (value "" = All / no filter).
      cvsStatusFilterOpt: [
        {
          value: "",
          text: "All",
        },
        {
          value: "1",
          text: "Triggered",
        },
        {
          value: "0",
          text: "Not Triggered",
        },
        {
          value: "2",
          text: "Submitted",
        },
      ],

      //  OBJECTS
      particularCandidateDetails: {
        failed: [],
        success: [],
      },

      filterObject: {
        filterType: "",
        filterSource: [],
        skillSets: [],
        createdByUserName: [],
        selectedDate: [],
        selectedUpdatedDate: [],
        cvsStatus: "",
      },
      exportExcel: {
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
        type: "2",
        skillSets: [],
      },
      selectedActivate: {},
      // candidateID whose row action (three-dot) menu is open; null = none
      openKebabId: null,
      // Columns (show/hide + reorder + resize), persisted to localStorage.
      // Name/Email/Phone/Skills are "locked" columns in this model (always
      // visible, reorderable); only the checkbox, Source and Actions cells are
      // truly fixed/hard-coded.
      TP_COLS_STORAGE_KEY: "talentpool.configColumns",
      configColsDefault: defaultTalentPoolCols(),
      configCols: defaultTalentPoolCols(),
      showColumnConfig: false,
      // Number of leading (visible) columns pinned to the left, in addition to
      // the always-pinned checkbox + Source. Default: the locked default
      // columns (Name/Email/Phone/Skills). The user sets this by dragging the
      // divider line in the column-config popover.
      TP_STICKY_KEY: "talentpool.stickyCols",
      stickyColCount: 4,
      // Visible width of the table scroller (see effectiveStickyCount).
      tableViewportWidth: 0,
      tableResizeObserver: null,
      // Configure-columns drag state; see bouncePinnedDivider.
      cfgDragging: false,
      pinDividerShake: false,
      pinDividerHold: null,
      resizingCol: null,
      resizeStartX: 0,
      resizeStartWidth: 0,
      // Trigger CVS from Talent Pool (job-less)
      showCvsTriggerModal: false,
      cvsSubmitting: false,
      cvsSuccessDetails: null,
      // Set when triggering for specific candidates (e.g. Re-Trigger CVS from
      // the preview sidebar) instead of the table selection.
      cvsTriggerCandidateIDs: null,
    };
  },
  validations: {
    folderName: {
      maxLength: maxLength(64),
      required,
    },
  },
  computed: {
    // Visible configurable columns in current order (drives both header and body).
    // The setter is used by vuedraggable to persist a reordered list.
    orderedVisibleCols: {
      get() {
        const isVendor = this.roles.includes("GET_VENDOR_DASHBOARD");
        return this.configCols.filter(
          (c) => c.visible && !(c.vendorHidden && isVendor)
        );
      },
      set(newOrder) {
        const hidden = this.configCols.filter((c) => !newOrder.includes(c));
        this.configCols = [...newOrder, ...hidden];
        this.persistConfigCols();
      },
    },
    // Columns listed in the config popover (hide vendor-only columns for vendors).
    // The setter lets vuedraggable reorder the columns from within the popover.
    configColsForMenu: {
      get() {
        const isVendor = this.roles.includes("GET_VENDOR_DASHBOARD");
        return this.configCols.filter((c) => !(c.vendorHidden && isVendor));
      },
      set(newOrder) {
        const excluded = this.configCols.filter((c) => !newOrder.includes(c));
        this.configCols = [...newOrder, ...excluded];
        this.persistConfigCols();
      },
    },
    // Width of the always-pinned leading cells (selection checkbox + Source).
    // The checkbox cell is only present when the user can select candidates.
    leadingStickyWidth() {
      const hasCheckbox =
        this.roles.includes("PUSH_CANDIDATE_JD") ||
        this.roles.includes("DELETE_CANDIDATE");
      return (hasCheckbox ? 50 : 0) + 80;
    },
    // Left offset (px) for the selection checkbox and Source lead cells.
    checkboxStickyLeft() {
      return 0;
    },
    sourceStickyLeft() {
      const hasCheckbox =
        this.roles.includes("PUSH_CANDIDATE_JD") ||
        this.roles.includes("DELETE_CANDIDATE");
      return hasCheckbox ? 50 : 0;
    },
    // Pinned columns actually applied: stickyColCount, reduced so the
    // scrolling columns always have room to be scrolled into view.
    effectiveStickyCount() {
      return this.pinnableCount(this.stickyColCount);
    },
    // Running left offset for each visible column when it is pinned (the first
    // `effectiveStickyCount` columns). Cells are border-box, so col.width is the
    // rendered outer width and the running sum lines header and body up exactly.
    // NOTE: bind the lead cells' widths in object form (`:style="{...}"`);
    // Vue 2 drops string entries of a `:style` array, which misaligns header
    // and body.
    stickyLeftOffsets() {
      const offsets = [];
      let left = this.leadingStickyWidth;
      this.orderedVisibleCols.forEach((col, idx) => {
        if (idx < this.effectiveStickyCount) {
          offsets[idx] = left;
          left += col.width;
        } else {
          offsets[idx] = null;
        }
      });
      return offsets;
    },
    // The config-popover list with a draggable divider inserted after the
    // columns actually pinned (effectiveStickyCount), or at pinDividerHold
    // during a snap-back. Columns above the divider are pinned left; below it
    // they scroll. Moving the divider updates stickyColCount.
    // Only shown columns are listed (and draggable); hidden ones are listed
    // A-Z below them (hiddenMenuCols).
    menuItems: {
      get() {
        const cols = this.configColsForMenu.filter((c) => c.visible);
        const visibleTotal = cols.filter((c) => c.visible).length;
        const shown =
          this.pinDividerHold !== null
            ? this.pinDividerHold
            : this.effectiveStickyCount;
        const boundary = Math.max(0, Math.min(shown, visibleTotal));
        const items = [];
        let seen = 0;
        let placed = false;
        cols.forEach((c) => {
          if (!placed && seen === boundary) {
            items.push({ _divider: true });
            placed = true;
          }
          items.push(c);
          if (c.visible) seen += 1;
        });
        if (!placed) items.push({ _divider: true });
        return items;
      },
      set(newItems) {
        // Visible columns above the divider = the new pinned count.
        let count = 0;
        for (const it of newItems) {
          if (it._divider) break;
          if (it.visible) count += 1;
        }
        const shownBefore = this.effectiveStickyCount;
        const newCols = newItems.filter((it) => !it._divider);
        const excluded = this.configCols.filter((c) => !newCols.includes(c));
        this.configCols = [...newCols, ...excluded];
        this.persistConfigCols();
        // Reorders that don't move the divider keep stickyColCount, which can
        // exceed what currently fits.
        if (count === shownBefore) return;
        // Divider dropped past the last pinnable column: save only what fits
        // and snap it back.
        const fit = this.pinnableCount(count);
        const tooLow = fit < Math.min(count, this.orderedVisibleCols.length);
        this.stickyColCount = tooLow ? fit : count;
        this.persistStickyCount();
        if (tooLow) this.bouncePinnedDivider(count, fit);
      },
    },
    // Hidden columns for the config popover, alphabetical so they are easy to
    // scan; their order is irrelevant until shown (see setColVisible).
    hiddenMenuCols() {
      return this.configColsForMenu
        .filter((c) => !c.visible)
        .sort((a, b) =>
          String(a.label).localeCompare(String(b.label), undefined, {
            sensitivity: "base",
          })
        );
    },
    checkThirdPartyAccess() {
      let val = this.thirdPartyData.data.find(
        (obj) => obj.thirdPartyID === "hire3xcvsearch"
      );
      if (!val) {
        return false;
      }
      return val.enabled;
    },
    vendColsCount() {
      if (
        this.vendorDetails &&
        this.vendorDetails.length === 0 &&
        this.searchVend !== ""
      ) {
        return 12;
      } else {
        return 6;
      }
    },
    // To check if it does not contain an alphabet or zero
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    showFilterDel() {
      if (this.searchname != "") {
        return true;
      } else if (
        this.allCandidateDetails.length === 0 &&
        this.filtercount == 0
      ) {
        return false;
      }
      return true;
    },
    minDate() {
      return this.startDate;
    },
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
    }),
    ...mapGetters(["roles"]),
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
    isEmpty: ({ candidateSelected }) => candidateSelected.length === 0,
    isEmptyJob: ({ jobSelected }) => jobSelected.length === 0,
    selCount() {
      return this.candidateSelected.length;
    },
    selectedCandidateCount() {
      let count;
      count =
        this.candidateSelected.length < 9
          ? "0" + this.candidateSelected.length
          : this.candidateSelected.length;
      return count;
    },
    cvsTargetCandidateIDs() {
      return this.cvsTriggerCandidateIDs || this.candidateSelected;
    },
    selectedCandidatesForCVS() {
      return this.allCandidateDetails
        .filter((cand) => this.cvsTargetCandidateIDs.includes(cand.candidateID))
        .map((cand) => ({
          candidateID: cand.candidateID,
          name: cand.name,
          email: cand.email,
        }));
    },
    disableApplyFilter() {
      if (
        this.filterObject.filterType.length == 0 &&
        this.filterObject.filterSource.length == 0 &&
        this.filterObject.skillSets.length == 0 &&
        this.filterObject.createdByUserName.length == 0 &&
        this.filterObject.selectedDate.length == 0 &&
        this.filterObject.selectedUpdatedDate.length == 0 &&
        this.filterObject.cvsStatus.length == 0
      ) {
        return true;
      }
      return false;
    },
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        this.LoaderStatus = true;
        if (newValue != "Loader") {
          this.getTalentPoolCandidateRedis();
        }
      }
    },
  },

  async created() {
    this.LoaderStatus = true;
    this.loadConfigCols();
    this.loadStickyCount();
    await this.getTalentPoolCandidateRedis();
    await this.getCustomField();
    // License/candidate-form fields become configurable (default-hidden) columns.
    this.mergeCustomFieldCols();
    this.loadConfigCols();
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    if (
      (this.$route.query.history || this.$route.query.preview) &&
      this.storedData
    ) {
      this.viewCandidateModal = true;
      this.viewCandidate(this.storedData.candidate);
    }
  },
  mounted() {
    const el = document.getElementById("top1");
    el.addEventListener("click", this.simple, false);
    EventBus.$on("applyAdvanceSearch", this.applyAdvanceSearch);
    document.body.addEventListener("mousedown", this.handleClose);
    document.addEventListener("click", this.closeKebab);
    document.addEventListener("click", this.closeColumnConfig);
    // Track the table's visible width for effectiveStickyCount.
    this.measureTableWidth();
    if (typeof ResizeObserver !== "undefined" && this.$refs.tableScroll) {
      this.tableResizeObserver = new ResizeObserver(this.measureTableWidth);
      this.tableResizeObserver.observe(this.$refs.tableScroll);
    } else {
      window.addEventListener("resize", this.measureTableWidth);
    }
  },
  beforeDestroy() {
    if (this.tableResizeObserver) this.tableResizeObserver.disconnect();
    window.removeEventListener("resize", this.measureTableWidth);
    document.body.removeEventListener("mousedown", this.handleClose);
    document.removeEventListener("click", this.closeKebab);
    document.removeEventListener("click", this.closeColumnConfig);
    document.removeEventListener("mousemove", this.onResize);
    document.removeEventListener("mouseup", this.stopResize);
    clearTimeout(this.pinBounceTimer);
  },
  filters: {
    fnName: function (value) {
      if (Array.isArray(value)) {
        if (value.length <= 3) {
          return value.join(", ");
        } else {
          return value.slice(0, 3).join(", ") + "...";
        }
      } else {
        return value;
      }
    },
  },
  methods: {
    goToBookmark() {
      this.$router.push({ name: "Bookmark" });
    },
    async showAddBookmark() {
      await this.getBookmarkFolders();
      this.showcreateFolder = false;
      this.$bvModal.show("bookmarkcandidate");
    },
    async bookmarkCands() {
      this.bookmarkLoader = true;
      try {
        let payload = {
          licenseKey: this.licenseKey,
          project: "recruitment_candidate_bookmark",
          action: "user",
          users: this.candidateSelected,
          folderIDs: this.selectedFolders,
          multiple: true,
          root: true,
        };
        const res = await addFolderUser(payload);
        if (res.status == 200) {
          let count = this.candidateSelected.length;
          this.candidateSelected = [];
          this.allSelected = false;
          this.closeBookmark();
          let cand = count == 1 ? "Candidate" : "Candidates";
          let toastText = `<strong>${count}  ${cand} </strong> have been added.`;
          this.dynamicToast("success", "Successfully Bookmarked", toastText);
        } else this.errorModal("Something went wrong!");
        this.bookmarkLoader = false;
      } catch (error) {
        this.errorModal("Something went wrong!");
        this.bookmarkLoader = false;
        console.error(error);
      }
    },
    async getBookmarkFolders() {
      try {
        let payload = {
          licenseKey: this.licenseKey,
          project: "recruitment_candidate_bookmark",
        };
        const res = await getBookmarkFolders(payload);
        if (res.status == 200) {
          this.folders = res.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async addFolder() {
      try {
        this.$v.$touch();
        if (!this.$v.folderName.$invalid) {
          this.bookmarkLoader = true;
          let payload = {
            licenseKey: this.licenseKey,
            project: "recruitment_candidate_bookmark",
            folderName: this.folderName,
            root: true,
          };
          const res = await addFolder(payload);
          if (res.status == 200) {
            await this.getBookmarkFolders();
            this.createFolder(res.data.data.folderID);
            this.successModal("Folder created");
          } else if (res.status == 409) {
            this.errorModal("Folder name already exists!");
          } else this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.errorModal("Something went wrong!");
        console.error(error);
      }
      this.bookmarkLoader = false;
    },
    selFolder(type, folder) {
      if (type == "add") {
        this.selectedFolders.push(folder.folderID);
      } else
        this.selectedFolders = this.selectedFolders.filter(
          (obj) => obj != folder.folderID
        );
      this.$forceUpdate();
    },
    createFolder(folderID) {
      this.selectedFolders.push(folderID);
      this.showcreateFolder = false;
      this.folderName = null;
      this.$v.folderName.$reset();
      this.$forceUpdate();
    },
    closeBookmark() {
      this.$bvModal.hide("bookmarkcandidate");
      this.selectedFolders = [];
      this.folderName = null;
      this.$v.folderName.$reset();
      // this.showcreateFolder = false;
    },
    setTagData(candidate) {
      let noteData = {
        type: "add",
        tags: [],
      };
      if (
        candidate.customFields.notesTags &&
        candidate.customFields.notesTags.length != 0
      ) {
        noteData.tags = candidate.customFields.notesTags;
      }
      this.noteTagData = noteData;
    },
    handleClose(event) {
      if (!event) return;
      if (
        this.$refs.closeCard &&
        !this.$refs.closeCard?.contains(event.target) &&
        !this.$refs.openCard?.contains(event.target) &&
        !document
          .getElementsByClassName("mx-calendar")[0]
          ?.contains(event.target) &&
        !document
          .getElementsByClassName("mx-calendar")[1]
          ?.contains(event.target)
      ) {
        this.showfiltercard = false;
      }
    },
    resetValues() {
      this.assignedCandidate = {};
      this.candidateSelected = [];
      this.getTalentPoolCandidateRedis();
      this.isReassign = false;
    },
    getReassign() {
      this.isReassign = true;
      this.$bvModal.show("reassignmodal");
    },
    closeAssignRec() {
      this.isReassign = false;
    },
    // candidateIDs: trigger for these candidates instead of the table selection.
    showTriggerCVS(candidateIDs = null) {
      this.cvsTriggerCandidateIDs = candidateIDs;
      this.cvsSuccessDetails = null;
      this.showCvsTriggerModal = true;
      this.$bvModal.show("trigger-cvs-talentpool");
    },
    // Drop one candidate from this trigger only; the table selection is kept.
    removeCvsCandidate(candidateID) {
      this.cvsTriggerCandidateIDs = this.cvsTargetCandidateIDs.filter(
        (id) => id !== candidateID
      );
    },
    closeTriggerCVS() {
      this.showCvsTriggerModal = false;
      this.cvsSuccessDetails = null;
      this.cvsSubmitting = false;
      this.cvsTriggerCandidateIDs = null;
    },
    async triggerCVSFromTalentPool(skills) {
      this.cvsSubmitting = true;
      try {
        let payload = {
          candidates: [...this.cvsTargetCandidateIDs],
        };
        if (skills && skills.length) {
          payload.skills = skills;
        }
        const res = await trigerCvs(payload);
        if (res.status == 200) {
          this.cvsSuccessDetails = {
            newlyAdded: res.data.data.data.newCandidates,
            alreadyExisting: res.data.data.data.oldCandidates,
          };
          this.cvsSubmitting = false;
          // Refresh so the CVS Status column reflects the new trigger.
          this.getTalentPoolCandidateRedis();
        } else {
          this.cvsSubmitting = false;
          this.errorModal("Something went wrong!");
          this.closeTriggerCVS();
        }
      } catch (error) {
        this.cvsSubmitting = false;
        this.errorModal("Something went wrong!");
        this.closeTriggerCVS();
        console.error(error);
      }
    },
    getRemainingNamesTooltip(userIcons) {
      const remainingNames = userIcons.slice(3).map((icon) => icon.name);
      return remainingNames.join(", ");
    },
    addNote(cand) {
      this.showAddNote = true;
      this.addNoteId = cand.candidateID;
    },
    closeAddNote() {
      this.noteTagData = {};
      this.showAddNote = false;
    },
    goToPagination() {
      if (this.filtercount == 0) {
        this.filterApplied = false;
      }
      this.getTalentPoolCandidateRedis();
      this.goToPage = null;
    },
    activateModal(i) {
      this.selectedActivate = i;
      this.$bvModal.show("activatemodal");
    },
    async activateCandidate() {
      try {
        this.selectedActivate.active = true;
        let anotherCand;
        anotherCand = JSON.parse(JSON.stringify(this.selectedActivate));

        let payload = {
          ...anotherCand,
        };

        const res = await putCandidate(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          const form = new FormData();
          form.append("type", this.parentID);
          form.append("candidateID", this.$route.params.candidateID);
          var attachment = [];
          for (const field of this.customFieldsArray) {
            const key =
              field.fieldType === "default"
                ? this.selectedActivate[field.key]
                : this.selectedActivate.customFields[field.key];
            if (
              field.controlType === "upload_file" &&
              field.isReupload &&
              key
            ) {
              let obj = {
                attachmentName: field.key,
              };
              attachment.push(obj);
              form.append(field.key, key);
            }
          }
          form.append("attachment", JSON.stringify(attachment));
          if (attachment.length !== 0) {
            await uploadDocumentAPI(form);
          }
          this.successModal("Candidate Activated Successfully");
        } else if (res.status == 208) {
          this.LoaderStatus = false;
        } else if (res.status == 409) {
          this.LoaderStatus = false;
          let errorMessage = res.data.data.Detail;
          this.errorModal(`${errorMessage}`);
        } else {
          this.LoaderStatus = false;
          this.errorModal("Something went wrong");
        }
        this.$bvModal.hide("activatemodal");
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong!");
        throw err;
      }
    },
    activateCand(i) {
      this.$router.push({
        name: "ActivateCandidate",
        params: {
          candidateID: i.candidateID,
        },
        query: {
          active: "" + i.active,
        },
      });
    },
    goToCVSearch(comp) {
      this.$store.commit("cvSearchVUEX/setJobIDs", []);
      this.$store.commit("cvSearchVUEX/setWhereFrom", "talentpool");
      this.$router.push({
        name: "cvSearchTalentPool",
        query: {
          component: comp,
        },
      });
    },
    updateFieldValue(field, data) {
      this.exportExcel[field] = data;
    },
    showCandModal() {
      this.showCandTPModal = true;
    },
    hideCandModal() {
      this.showCandTPModal = false;
    },
    showFilter() {
      console.log(this.showfiltercard);
      if (this.showfiltercard) {
        this.showfiltercard = false;
      } else {
        this.filterObject.filterSource = this.storeFilterSource;
        this.filterObject.filterType = this.storeFilterType;
        this.filterObject.skillSets = this.storeFilterSkills;
        this.filterObject.createdByUserName = this.storeFilterAddedBY;
        this.filterObject.selectedDate = this.storeFilterDate;
        this.filterObject.selectedUpdatedDate = this.storeFilterUpdatedDate;
        this.filterObject.cvsStatus = this.storeFilterCvs;
        this.showfiltercard = true;
      }
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    cancelFilter() {
      this.filterObject.filterSource = this.storeFilterSource;
      this.filterObject.filterType = this.storeFilterType;
      this.filterObject.skillSets = this.storeFilterSkills;
      this.filterObject.createdByUserName = this.storeFilterAddedBY;
      this.filterObject.selectedDate = this.storeFilterDate;
      this.filterObject.selectedUpdatedDate = this.storeFilterUpdatedDate;
      this.filterObject.cvsStatus = this.storeFilterCvs;
      this.showfiltercard = false;
    },
    applyAdvanceSearch(data) {
      this.advancedFilters = data;
      // Surface any filtered-on columns that aren't currently shown, placing
      // them right after the pinned-left columns.
      this.autoShowFilteredCols(data);
      this.getTalentPoolCandidateRedis();
    },
    // "Clear filters" from the no-results empty state: drop the advanced filters
    // and any text search, reset the advanced-search header UI, and reload the
    // full list — with a single refetch.
    clearAllFilters() {
      this.advancedFilters = [];
      this.filtercount = 0;
      // Reset the advanced-search header's own rows / applied indicator (it does
      // not refetch — we do, once, below).
      EventBus.$emit("clearTalentPoolFilters");
      if (this.searchQuery) {
        // Clearing the text search fires the searchQuery watcher, which reloads.
        this.$store.commit("searchVUEX/saveSearchQuery", "");
      } else {
        this.getTalentPoolCandidateRedis();
      }
    },
    updatePage(value) {
      this.pageCount = value;
      this.currentPage = 1;
      this.getTalentPoolCandidateRedis();
    },
    openAddToJob() {
      this.showJobOppurtunity = false;
      this.showAddToJd = true;
    },
    openJobOppurtunity() {
      this.showAddToJd = true;
      this.showJobOppurtunity = true;
    },
    handleCandidatesSelected() {
      this.showAddToJd = false;
    },
    closeAddToJdModal() {
      this.showAddToJd = false;
      // Clear cafndidateSelected array in the parent component
      this.candidateSelected = [];
      this.allSelected = false;
    },

    // v-closable for add candidates toggle
    hideaddToggle() {
      this.addCandidateToggle = false;
    },
    handleAddCandidates(newVal) {
      this.addMultipleCandidates = newVal;
    },
    handleCloseMultple(newVal) {
      this.checkMultiple = newVal;
    },
    handleAdd(newVal) {
      this.addMultipleCandidates = newVal;
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    applyTalentFilterTest() {
      this.filterApplied = true;
      this.LoaderStatus = true;
      this.filtercount = 0;
      this.showfiltercard = false;
      this.getTalentPoolCandidateRedis();
      this.storeFilterSource = this.filterObject.filterSource;
      this.storeFilterType = this.filterObject.filterType;
      this.storeFilterSkills = this.filterObject.skillSets;
      this.storeFilterAddedBY = this.filterObject.createdByUserName;
      this.storeFilterDate = this.filterObject.selectedDate;
      this.storeFilterUpdatedDate = this.filterObject.selectedUpdatedDate;
      this.storeFilterCvs = this.filterObject.cvsStatus;
    },
    //OPEN MODAL FOR UPLOADING EXCEL
    openExcelModal() {
      this.addMultipleCandidates = true;
      this.addCandidateToggle = false;
      this.$bvModal.show("excel-modal-center");
    },
    vendSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.page = 0;
        this.getVendors();
      }, 400);
    },

    async exportResume(data) {
      try {
        this.LoaderStatus = true;
        let payload = {
          candidateID: data.candidateID,
        };
        const res = await getResume(payload);
        if (res.status == 200) {
          const link = res.data.data.resumeLink;
          // implemented bcz once we click on download resume that page shouldn't go blank
          const candidateName = res.data.data.name;

          await downloadResumeFile(link, candidateName);
          this.LoaderStatus = false;
          this.successModal("Resume downloaded successfully");
        } else {
          this.LoaderStatus = false;
        }
      } catch (error) {
        this.LoaderStatus = false;
        console.error(error);
      }
    },
    // Method to validate skill tags
    tagValidatorskill(tag) {
      let skill_list = this.areaofexp.map((s) => s.toLowerCase());
      return !skill_list.includes(tag.toLowerCase());
    },
    calldeletemodal() {
      !this.roles.includes("GET_VENDOR_DASHBOARD")
        ? this.$bvModal.show("modaldelete")
        : this.$bvModal.show("deleteconfirmvendor");
    },
    convertToLowerCase(data) {
      return data.toLowerCase();
    },
    removevend(index) {
      this.selectVend.splice(index, 1);
    },
    changeView(data) {
      this.body.forEach((object) => {
        if (object.customerID == data.customerID) {
          object.view = !object.view;
        } else {
          object.view = false;
        }
        this.$forceUpdate();
      });
    },
    async getVendors() {
      try {
        this.$bvModal.show("addjdmodal-2");
        this.showLoader = true;
        let payload = {
          searchQuery: this.searchVend,
          sortColumn: this.sortColumn,
          sortOrder: this.sortOrder,
          page: this.page,
          count: this.vendCount,
        };
        const res = await getVendorJd(payload);
        if (res.status == 200) {
          this.vendtotalData = res.data.data.total;
          if (this.page == 0) {
            this.vendorDetails = res.data.data.data;
          } else {
            this.vendorDetails = [...this.vendorDetails, ...res.data.data.data];
          }
          this.vendPageEnd = res.data.data.pageEnd;
          if (res.data.data.total == res.data.data.pageEnd) {
            this.vendLoader = false;
          } else {
            this.vendLoader = true;
          }
          this.showLoader = false;
        }
      } catch (error) {
        return error;
      }
    },
    scrollVendors(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (this.checkbetween(this.vendPageEnd, 0, this.vendtotalData)) {
          this.page++;
          this.getVendors();
        }
      }
    },
    clearfilter(flag) {
      this.applyflag = flag;
      this.filtercount = 0;
      this.filterObject = {
        filterType: "",
        filterSource: [],
        skillSets: [],
        createdByUserName: [],
        selectedDate: [],
        selectedUpdatedDate: [],
        cvsStatus: "",
      };
      if (this.applyflag) {
        this.currentPage = 1;
        this.storeFilterSource = [];
        this.storeFilterType = "";
        this.storeFilterSkills = [];
        this.storeFilterAddedBY = [];
        this.storeFilterDate = [];
        this.storeFilterUpdatedDate = [];
        this.storeFilterCvs = "";
        this.getTalentPoolCandidateRedis();
      }
      this.applyflag = false;
    },
    clearexport() {
      this.exportExcel = {
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
        type: "2",
        skillSets: [],
      };
      this.showexportcard = false;
      this.exportLoader = false;
    },
    // GO TO ANY PAGE
    goToPages() {
      if (this.goToPage >= 1) {
        this.currentPage = this.goToPage;
        this.goToPage = null;
      }
    },
    formatYearsDate(dateString) {
      return formatYearsDate(dateString);
    },
    formatDateToISO(dateStr) {
      const [day, month, year] = dateStr.split("-");
      return `${year}-${month}-${day}`;
    },
    // Get List of candidates in Excel
    async exportcandidate() {
      this.exportLoader = true;
      let { source, addedBy, ...rest } = this.exportExcel;
      let payload = {
        ...rest,
        excel: true,
        page: 0,
        count: "all",
        filters: {
          ...this.exportExcel.filters,
          source: source,
          createdByUserName: addedBy,
        },
      };
      if (payload.startDate) {
        payload.startDate = this.formatDateToISO(payload.startDate);
      }
      if (payload.endDate) {
        payload.endDate = this.formatDateToISO(payload.endDate);
      }
      const res = await getTalentPoolCandidateRedis(payload);
      if (res.status == 200) {
        const link = res.data.data.S3link;
        // Create an anchor element
        const a = document.createElement("a");
        a.href = link;

        // Trigger a click event on the anchor element
        a.click();
        this.LoaderStatus = false;
        this.successModal("Excel exported successfully!");
        this.clearexport();
      } else {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
        this.clearexport();
      }
    },

    addtojddetails(data) {
      this.particularCandidateDetails = data;
    },
    clearaddvendmodal() {
      this.page = 0;
      this.selectVend = [];
      this.searchVend = "";
      this.vendLoader = false;
    },
    clearvendDetails() {
      this.$nextTick(() => {
        this.particularCandidateDetails = { failed: [], success: [] };
        this.addjddata = [];
        this.jobSelected = [];
        this.candidateSelected = [];
        this.selectVend = [];
        this.allSelected = false;
      });
      this.$bvModal.hide("addVendModal");
    },
    textSearch() {
      this.LoaderStatus = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getTalentPoolCandidateRedis();
      }, 300);
    },

    // Get  All candidates details function
    // Maps a virtual date row onto its start/end backend params, honouring the
    // operator: "between" fills both bounds, After fills only start (>=),
    // Before fills only end (<=).
    applyDateRange(row, setStart, setEnd) {
      const op = row.operator || "between";
      const single = Array.isArray(row.value) ? row.value[0] : row.value;
      if (op === "greater_than") {
        setStart(this.formatYearsDate(single));
      } else if (op === "less_than") {
        setEnd(this.formatYearsDate(single));
      } else {
        setStart(this.formatYearsDate(row.value[0]));
        setEnd(this.formatYearsDate(row.value[1]));
      }
    },
    async getTalentPoolCandidateRedis() {
      this.applyflag = true;
      this.LoaderStatus = true;
      let payload = {
        type: "2",
        count: this.pageCount,
        page: this.currentPage - 1,
        sortBy: this.buildSortBy(),
        searchQuery: this.searchQuery,
        skillSets: [],
        filters: {
          source: "",
          createdByUserName: [],
        },
        advancedFilters: [],
      };
      // Unified filter: the advanced-search rows drive everything. "Virtual"
      // rows (the common table filters) map onto the existing backend params;
      // every other row is a generic field match sent via advancedFilters.
      this.filtercount = (this.advancedFilters || []).length;
      const genericFilters = [];
      const firstVal = (v) => (Array.isArray(v) ? v[0] : v);
      for (const row of this.advancedFilters || []) {
        if (!row.virtual) {
          genericFilters.push(row);
          continue;
        }
        switch (row.key) {
          case "skills":
            // Route skills through the operator-aware advancedFilters matcher
            // so includes any / all / does-not-include are honoured.
            genericFilters.push(row);
            break;
          case "source":
            payload.filters.source = row.value;
            break;
          case "addedBy":
            payload.filters.createdByUserName = row.value;
            break;
          case "cvsStatus":
            // Multi-select + is / is_not, applied by the dedicated CVS filter.
            payload.filters.cvsStatus = Array.isArray(row.value)
              ? row.value
              : [row.value];
            payload.filters.cvsStatusOp = row.operator || "is";
            break;
          case "status":
            payload.type = firstVal(row.value);
            break;
          case "createdAt":
            this.applyDateRange(
              row,
              (v) => (payload.startDate = v),
              (v) => (payload.endDate = v)
            );
            break;
          case "updatedAt":
            this.applyDateRange(
              row,
              (v) => (payload.updatedStartDate = v),
              (v) => (payload.updatedEndDate = v)
            );
            break;
          default:
            genericFilters.push(row);
        }
      }
      payload.advancedFilters = genericFilters;

      if (this.roles.includes("GET_VENDOR_DASHBOARD")) {
        payload["vendor"] = true;
      }

      await getTalentPoolCandidateRedis(payload)
        .then((res) => {
          if (res.status == 200) {
            this.allCandidateDetails = res.data.data.data;
            for (let cand of this.allCandidateDetails) {
              cand.userIcons = [];
              for (let user of cand.visibleTo) {
                if (typeof user.username === "string") {
                  let name = user.username;
                  if (user.username.includes(" ")) {
                    const initials = user.username
                      .split(" ")
                      .map((word) => word.charAt(0).toUpperCase())
                      .join("");
                    name = user.username;
                    cand.userIcons.push({ initials, name });
                  } else {
                    const initials = user.username.slice(0, 1).toUpperCase();
                    cand.userIcons.push({ initials, name });
                  }
                }
              }
            }

            this.LoaderStatus = false;
            this.pageStart = res.data.data.pageStart;
            this.pageEnd = res.data.data.pageEnd;
            this.total = res.data.data.total;
            this.checkSelectAll();
            this.showfiltercard = false;
            this.dbfilterdrop = false;
          } else {
            this.LoaderStatus = false;
          }
          // The table scrolls vertically on the outer container (so the header
          // and the pinned Actions column can stay sticky), reset it to the top.
          const element = this.$refs.tableScroll;
          if (element) {
            element.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }
        })

        .catch((err) => {
          this.LoaderStatus = false;
          throw err;
        });
    },

    //to close filter card after clicking outside
    closefiltercard() {
      // this.showfiltercard = false;
    },

    checkbetween(x, min, max) {
      return x > min && x < max;
    },

    async addvendcand() {
      this.addCandidateToJD(this.selectVend, "addjdmodal-2");
      this.clearaddvendmodal();
    },
    async addCandidateToJD(selectedItems, modalId) {
      this.showLoader = true;
      const jobData = selectedItems.map((data) => data.jobID);

      try {
        const data = {
          candidateIDs: this.candidateSelected,
          jobIDs: jobData,
        };
        const response = await addtojd(data);

        if (response.status === 200) {
          this.$bvModal.show("addVendModal");
          this.showLoader = false;
          this.addjddata = response.data.data.jds;
          this.particularCandidateDetails = this.addjddata[0];
          this.successModal(response.data.data.Details);
        }

        this.$bvModal.hide(modalId);
      } catch (error) {
        this.errorModal("Something went wrong!");
        this.candidateSelected = [];
        this.jobSelected = [];
        this.$bvModal.hide(modalId);
      }
    },

    selectAll() {
      for (let i in this.allCandidateDetails) {
        if (
          this.allSelected &&
          this.candidateSelected.filter(
            (value) => value == this.allCandidateDetails[i].candidateID
          ).length === 0 &&
          (this.allCandidateDetails[i].active ||
            this.allCandidateDetails[i].active == null)
        ) {
          this.candidateSelected.push(this.allCandidateDetails[i].candidateID);
        } else if (
          !this.allSelected &&
          this.candidateSelected.filter(
            (value) => value == this.allCandidateDetails[i].candidateID
          ).length > 0 &&
          (this.allCandidateDetails[i].active ||
            this.allCandidateDetails[i].active === null)
        ) {
          this.candidateSelected.splice(
            this.candidateSelected.indexOf(
              this.allCandidateDetails[i].candidateID
            )
          );
        }
      }
    },

    deselect() {
      this.allSelected = false;
      const activeCandidateIDs = this.allCandidateDetails
        .filter((candidate) => candidate.active)
        .map((candidate) => candidate.candidateID);

      const containsAllActive = activeCandidateIDs.every((candidateID) =>
        this.candidateSelected.includes(candidateID)
      );

      if (containsAllActive) {
        this.allSelected = true;
      }
    },
    checkSelectAll() {
      let isSelectedAll = true;
      if (this.allCandidateDetails.length !== 0) {
        for (let record of this.allCandidateDetails) {
          if (
            (this.candidateSelected.filter(
              (value) => value == record.candidateID
            ).length === 0 &&
              record.active) ||
            record.active == null
          ) {
            isSelectedAll = false;
            break;
          }
        }
      } else {
        isSelectedAll = false;
      }
      this.allSelected = isSelectedAll;
    },
    viewCandidate(cand) {
      this.selectedCandidate = cand;
    },
    // Whole-row click opens the candidate preview sidebar (replaces the old eye icon).
    openCandidatePreview(cand) {
      this.selectedCandidate = cand;
      this.viewCandidateModal = true;
    },
    // Row action (three-dot) menu open/close. Toggle and menu use @click.stop, so the
    // document listener below only fires for outside clicks.
    toggleKebab(candidateID) {
      this.openKebabId = this.openKebabId === candidateID ? null : candidateID;
    },
    closeKebab() {
      this.openKebabId = null;
    },
    // ---- Configurable columns (persisted in localStorage) ----
    loadConfigCols() {
      try {
        const raw = localStorage.getItem(this.TP_COLS_STORAGE_KEY);
        if (!raw) return;
        const saved = JSON.parse(raw);
        if (!Array.isArray(saved)) return;
        const byKey = {};
        this.configCols.forEach((c) => (byKey[c.key] = c));
        const merged = [];
        // Apply saved order + visibility + width for columns we still know about.
        saved.forEach((s) => {
          const def = byKey[s.key];
          if (def) {
            if (typeof s.visible === "boolean") def.visible = s.visible;
            if (typeof s.width === "number" && s.width > 0) def.width = s.width;
            merged.push(def);
            delete byKey[s.key];
          }
        });
        // Columns not present in the saved config (added since it was saved).
        // Locked default columns lead in their default order so an older saved
        // config (from before Name/Email/Phone/Skills were part of the model)
        // still shows them up front; anything else keeps its default trailing
        // position.
        const newCols = this.configCols.filter((c) => byKey[c.key]);
        this.configCols = [
          ...newCols.filter((c) => c.locked),
          ...merged,
          ...newCols.filter((c) => !c.locked),
        ];
        // Locked columns are always visible, whatever a stale saved state says.
        this.configCols.forEach((c) => {
          if (c.locked) c.visible = true;
        });
      } catch (e) {
        // corrupt or unavailable storage: keep defaults
      }
    },
    persistConfigCols() {
      try {
        const payload = this.configCols.map((c) => ({
          key: c.key,
          visible: c.visible,
          width: c.width,
        }));
        localStorage.setItem(this.TP_COLS_STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {
        // storage unavailable (e.g. private mode): ignore
      }
    },
    persistStickyCount() {
      try {
        localStorage.setItem(this.TP_STICKY_KEY, String(this.stickyColCount));
      } catch (e) {
        // storage unavailable: ignore
      }
    },
    loadStickyCount() {
      try {
        const raw = localStorage.getItem(this.TP_STICKY_KEY);
        if (raw === null) return;
        const n = parseInt(raw, 10);
        if (!isNaN(n) && n >= 0) this.stickyColCount = n;
      } catch (e) {
        // corrupt/unavailable storage: keep default
      }
    },
    // Toggle a column's visibility from the config popover. If a pinned column
    // is hidden, shrink the pinned boundary with it so the same columns stay
    // pinned; always keep stickyColCount within the visible range.
    setColVisible(col, value) {
      if (!value) {
        const idx = this.orderedVisibleCols.indexOf(col);
        if (idx > -1 && idx < this.stickyColCount) {
          this.stickyColCount = Math.max(0, this.stickyColCount - 1);
        }
      }
      if (value) {
        // Newly shown columns join the end of the shown ones (the hidden list
        // is alphabetical, so their stored position means nothing).
        const rest = this.configCols.filter((c) => c !== col);
        let lastShown = -1;
        rest.forEach((c, i) => {
          if (c.visible) lastShown = i;
        });
        rest.splice(lastShown + 1, 0, col);
        this.configCols = rest;
      }
      col.visible = value;
      const visibleCount = this.orderedVisibleCols.length;
      if (this.stickyColCount > visibleCount)
        this.stickyColCount = visibleCount;
      this.persistConfigCols();
      this.persistStickyCount();
    },
    // Append license/candidate-form (custom) fields as configurable columns.
    // Sort payload for the list API. Every column is sortable; map the frontend
    // column key to the backend field path and a type hint so the backend can
    // sort by type (string case-insensitive, date/number/boolean/array direct,
    // "size" for the Accessible By count).
    // Sort cycle for a column header: nosort -> asc -> desc -> removed.
    // Updated At (the default order) toggles desc <-> asc instead.
    applySortColumn(colKey, asc) {
      this.statusValue = colKey;
      this.sortByValue = asc;
      this.filter = true;
      this.getTalentPoolCandidateRedis();
    },
    // Third click clears the sort: back to the default order (Updated At, newest
    // first), shown as the desc arrow on Updated At.
    clearSort() {
      this.statusValue = "updatedAt";
      this.sortByValue = false;
      this.filter = false;
      this.getTalentPoolCandidateRedis();
    },
    buildSortBy() {
      const key = this.statusValue;
      const order = this.sortByValue;
      if (!key) return { column: "", order, type: "string" };
      // Source is an always-pinned lead cell, not a configurable column.
      if (key === "source") return { column: "source", order, type: "string" };
      const col = (this.configCols || []).find((c) => c.key === key);
      if (!col) return { column: key, order, type: "string" };
      return {
        column: this.sortBackendField(col),
        order,
        type: this.sortBackendType(col),
      };
    },
    sortBackendField(col) {
      if (col.type === "custom") return "customFields." + col.fieldKey;
      const map = {
        phone: "phoneNumber",
        addedBy: "createdByUserName",
        status: "active",
        experience: "experince",
        accessibleBy: "visibleTo",
      };
      return map[col.key] || col.key;
    },
    sortBackendType(col) {
      if (col.type === "custom") {
        switch (col.controlType) {
          case "boolean":
            return "boolean";
          case "date":
            return "date";
          case "number":
            return "number";
          case "multi_select":
            return "array";
          default:
            return "string";
        }
      }
      const map = {
        updatedAt: "date",
        createdAt: "date",
        cvsStatus: "number",
        experience: "number",
        status: "boolean",
        skills: "array",
        accessibleBy: "size",
      };
      return map[col.key] || "string";
    },
    // When advanced search filters on a field whose column is hidden, turn that
    // column on and move it right after the pinned-left columns. Multiple such
    // fields are all added, in the order they appear in the search.
    autoShowFilteredCols(rows) {
      const newlyShown = [];
      for (const row of rows || []) {
        const rk = String((row && row.key) || "");
        if (!rk) continue;
        const colKey = rk.startsWith("customFields.")
          ? "cf:" + rk.slice("customFields.".length)
          : rk;
        const col = (this.configCols || []).find((c) => c.key === colKey);
        // Locked columns (name/email/phone/skills) are always visible; unknown
        // keys (e.g. Source, or top-level default fields with no column) skip.
        if (!col || col.locked) continue;
        if (!col.visible && !newlyShown.includes(col)) {
          col.visible = true;
          newlyShown.push(col);
        }
      }
      if (!newlyShown.length) return;
      const isVendor = this.roles.includes("GET_VENDOR_DASHBOARD");
      const showSet = new Set(newlyShown);
      const remaining = this.configCols.filter((c) => !showSet.has(c));
      // Insert right after the stickyColCount-th visible (non-vendor-hidden)
      // column — i.e. immediately following the pinned-left block.
      let seen = 0;
      let insertAt = remaining.length;
      for (let idx = 0; idx < remaining.length; idx++) {
        const c = remaining[idx];
        if (c.visible && !(c.vendorHidden && isVendor)) {
          seen++;
          if (seen >= this.stickyColCount) {
            insertAt = idx + 1;
            break;
          }
        }
      }
      remaining.splice(insertAt, 0, ...newlyShown);
      this.configCols = remaining;
      this.persistConfigCols();
    },
    mergeCustomFieldCols() {
      const existing = new Set(this.configCols.map((c) => c.key));
      (this.customFieldsArray || []).forEach((field) => {
        if (!field || !field.key) return;
        // "default" fields (name, email, mobile, source, ...) live at the
        // candidate top level, not under customFields, and several are already
        // shown as fixed columns. Only true custom/predefined fields (stored
        // under candidate.customFields, which colText reads) are configurable.
        if (field.fieldType === "default") return;
        if (field.controlType === "upload_file" || field.key === "resume") {
          return;
        }
        const colKey = "cf:" + field.key;
        if (!existing.has(colKey)) {
          this.configCols.push({
            key: colKey,
            label: fieldDisplayLabel(field, this.customFieldsArray),
            visible: false,
            width: 140,
            type: "custom",
            fieldKey: field.key,
            controlType: field.controlType,
            // Select fields store option keys; keep the {key,label} options so
            // colText can render the human-readable label instead of the key.
            values: Array.isArray(field.values) ? field.values : [],
          });
          existing.add(colKey);
        }
      });
    },
    // Text value for the generic (non-special-rendered) configurable columns.
    colText(candidate, col) {
      if (col.key === "updatedAt") {
        return this.formatUpdatedAt(candidate.updatedAt);
      }
      if (col.key === "createdAt") {
        return this.formatUpdatedAt(candidate.createdAt);
      }
      if (col.key === "experience") return candidate.experince || "-";
      if (col.key === "addedBy") return candidate.createdByUserName || "-";
      if (col.type === "custom") {
        const v = candidate.customFields
          ? candidate.customFields[col.fieldKey]
          : null;
        if (v === undefined || v === null || v === "") return "-";
        // boolean fields store true/false; show a readable Yes/No.
        if (col.controlType === "boolean") return v === true ? "Yes" : "No";
        // single/multi select store the option key(s); show the option label.
        const opts = col.values || [];
        const labelOf = (item) => {
          if (item && typeof item === "object") {
            return item.username || item.name || item.label || "-";
          }
          const match = opts.find((o) => o.key === item);
          return match ? match.label : item;
        };
        if (Array.isArray(v)) {
          return v.length ? v.map(labelOf).join(", ") : "-";
        }
        return labelOf(v);
      }
      return "-";
    },
    toggleColumnConfig() {
      this.showColumnConfig = !this.showColumnConfig;
    },
    // How many of the first `requested` visible columns can be pinned: the
    // left-pinned block (lead cells + pinned columns) plus the right-pinned
    // Actions column (80px) must leave room for the widest scrolling column.
    pinnableCount(requested) {
      const cols = this.orderedVisibleCols;
      let count = Math.min(requested, cols.length);
      const avail = this.tableViewportWidth;
      if (!avail) return count;
      const fixed = this.leadingStickyWidth + 80;
      while (count > 0) {
        const pinned = cols
          .slice(0, count)
          .reduce((sum, c) => sum + c.width, 0);
        const widestScrolling = Math.max(
          0,
          ...cols.slice(count).map((c) => c.width)
        );
        if (fixed + pinned + widestScrolling <= avail) break;
        count -= 1;
      }
      return count;
    },
    // Shakes the divider at the drop position, then releases it to the last
    // pinnable column (animated by the transition-group) and shows a toast.
    bouncePinnedDivider(requested, fit) {
      clearTimeout(this.pinBounceTimer);
      this.pinDividerHold = requested;
      this.$nextTick(() => {
        this.pinDividerShake = true;
        this.pinBounceTimer = setTimeout(() => {
          this.pinDividerShake = false;
          this.pinDividerHold = null;
          this.$nextTick(this.scrollPinnedDividerIntoView);
          const last = this.orderedVisibleCols[fit - 1];
          this.dynamicToast(
            "warning",
            "Pinned left moved",
            fit
              ? `Only ${fit} of ${requested} pinned columns fit on this screen, so the pin was moved up to "${last.label}".`
              : `None of the ${requested} pinned columns fit on this screen, so the pin was moved to the top.`
          );
        }, 450);
      });
    },
    // Sortable scrollFn for the Configure columns list. Scrolls by elapsed
    // time (120px/s) because Sortable may call it from several timers at once.
    // Sub-pixel remainders carry over since scrollTop is whole pixels.
    cfgAutoScroll(dx, dy, evt, touchEvt, el) {
      const now = performance.now();
      const last = this.cfgScrollAt || now;
      this.cfgScrollAt = now;
      if (!dy) return;
      const elapsed = Math.min(now - last, 50);
      this.cfgScrollCarry =
        (this.cfgScrollCarry || 0) + (Math.sign(dy) * 120 * elapsed) / 1000;
      const step = Math.trunc(this.cfgScrollCarry);
      if (step) {
        el.scrollTop += step;
        this.cfgScrollCarry -= step;
      }
    },
    // Scrolls the Configure columns list (not the page) so the divider is
    // visible after a snap-back.
    scrollPinnedDividerIntoView() {
      const list = this.$refs.cfgList;
      const row = list && list.querySelector(".tp-cfg-divider-row");
      if (!row) return;
      const top = row.offsetTop - list.offsetTop;
      const bottom = top + row.offsetHeight;
      let target = null;
      if (top < list.scrollTop) target = top - row.offsetHeight;
      else if (bottom > list.scrollTop + list.clientHeight)
        target = bottom - list.clientHeight + row.offsetHeight;
      if (target !== null)
        list.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
    },
    // Revert column visibility, order and widths to the shipped default.
    resetConfigCols() {
      this.configCols = defaultTalentPoolCols();
      this.mergeCustomFieldCols();
      this.stickyColCount = 4;
      this.persistConfigCols();
      this.persistStickyCount();
      this.closeColumnConfig();
    },
    closeColumnConfig() {
      this.showColumnConfig = false;
    },
    measureTableWidth() {
      const el = this.$refs.tableScroll;
      if (el) this.tableViewportWidth = el.clientWidth;
    },
    startResize(e, col) {
      this.resizingCol = col;
      this.resizeStartX = e.clientX;
      this.resizeStartWidth = col.width;
      document.addEventListener("mousemove", this.onResize);
      document.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      const dx = e.clientX - this.resizeStartX;
      const w = Math.max(80, this.resizeStartWidth + dx);
      if (this.resizingCol) {
        this.resizingCol.width = w;
      }
    },
    stopResize() {
      const wasCol = this.resizingCol;
      this.resizingCol = null;
      document.removeEventListener("mousemove", this.onResize);
      document.removeEventListener("mouseup", this.stopResize);
      if (wasCol) this.persistConfigCols();
    },
    formatUpdatedAt(dateStr) {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return "-";
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    // Mirrors the workbench CVS status: 1 = Triggered, 2 = Submitted, else Not Triggered.
    cvsStatusLabel(status) {
      return status == 1
        ? "Triggered"
        : status == 2
        ? "Submitted"
        : "Not Triggered";
    },
    cvsStatusColor(status) {
      return status == 1 ? "#8C8C8C" : status == 2 ? "#038E00" : "#20639B";
    },
    closeViewIcon() {
      this.viewCandidateModal = false;
      this.selectedCandidate = {}; // Update selectedCandidate based on the event
    },
    closemodaldeleteselected() {
      this.$bvModal.hide("modal-delete-selected");
    },
    talentPoolAddBtn() {
      // customer ID delete
      let customerID = "";
      this.$store.commit("customerVUEX/savecustomerID", customerID);
    },
    editCandidate(data) {
      this.$router.push({
        name: "EditCandidate",
        params: {
          candidateID: data.candidateID,
        },
        query: {
          active: "" + data.active,
        },
      });
    },
    delCandidate(cand) {
      this.deleteCandidate = cand;
    },
    async deleteParticularCandidate(vendorflag) {
      try {
        this.LoaderStatus = true;
        for (let i in this.allCandidateDetails) {
          for (let j in this.candidateSelected) {
            if (
              this.allCandidateDetails[i].candidateID ==
              this.candidateSelected[j].candidateID
            ) {
              this.candidateSelected[i].active = false;
            }
          }
        }
        let data = {
          candidateID: this.candidateSelected,
          vendor: vendorflag,
        };
        const res = await deleteCandidate(data);
        if (res.status == 200) {
          setTimeout(() => {
            if (this.candidateSelected.length == 1) {
              this.successModal("Candidate deleted successfully!");
            } else if (this.candidateSelected.length > 1) {
              this.successModal("Candidates deleted successfully!");
            }
            this.getTalentPoolCandidateRedis();
            this.candidateSelected = [];
          }, 1500);
        } else {
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.errorModal("Something went wrong");
        throw new Error(`Delete Candidate  Failed! status: ${error.status}`);
      }
      this.$bvModal.hide("modaldelete");
      this.$bvModal.hide("deleteconfirmvendor");
    },
  },
};
</script>

<style>
.failed-count {
  background-color: #fc451e;
  border-radius: 50%;
  font-size: 9px;
  height: 20px;
  width: 20px;
  color: #ffffff;
  margin-left: 7px;
}

.resume-name {
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80px;
  margin-top: 4px;
}

.custom-file-uploaded {
  padding: 6px 12px;
  background: #d0f9cf;
  width: 150px;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  background: #72738e;
  cursor: pointer;
  color: #ffffff;
  border-radius: 3px;
}

.done-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.upload-cand-modal > thead {
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}

.jdtablecontent tbody {
  display: block;
  border-radius: 5px;
  overflow-x: auto;
  height: calc(100vh - 360px);
  margin-top: 5px;
  width: calc(100% + 15px);
}

.jdtablecontent tbody tr:hover {
  background: #e7e8f5;
}

.aoesearchicon-pos {
  position: absolute;
  top: 5px;
  left: 5px;
}

.aoeinput > input {
  padding: 0.75rem 1.25rem !important;
  border: unset;
  border-radius: unset;
  border-bottom: 1px solid #ced4da;
}

.secdropdowncolor:nth-child(odd) {
  font-weight: 400;
  font-size: 13px;
  padding: 0.5rem 1.75rem !important;
  color: #545454;
  background: #f4f4f4;
}

.secdropdowncolor:nth-child(even) {
  font-weight: 400;
  font-size: 13px;
  padding: 0.5rem 1.75rem !important;
  color: #545454;
  background: var(--bg-white);
}

.height-dropdown-container {
  min-height: auto;
  max-height: 180px;
  overflow: auto;
}

.dropdown-container {
  padding: 5px 15px;
  background: #ffffff;
  border: 0.7px solid rgba(114, 115, 142, 0.5);
  box-shadow: 0px 4px 14px rgb(0 0 0 / 12%);
  border-radius: 5px;
  position: absolute;
  width: 90%;
  z-index: 3;
}

.talentPoolcandidateToggle {
  position: absolute;
  top: 35px;
  right: 0px;
  background: #ffffff;
  box-shadow: 0px 1px 11px 0px #00000061;
  border-radius: 5px;
  padding: 10px;
  z-index: 3;
  width: 240px !important;
}

/* The Add Candidate dropdown shares the root stacking context with the sticky
   table header (z-index:5) — its ancestors create no stacking context — so at
   z-index:3 it was painted behind the column names. Lift it above the header
   (but below the loader overlay at z-index:10). Two-class selector so it wins
   over the base z-index:3 above regardless of source order. */
.talentPoolcandidateToggle.candidate-z-index {
  z-index: 8;
}

.talentPoolcandidateToggle .unselOption {
  font-weight: 600;
  font-family: var(--lato);
  font-size: 13px;
  padding: 8px !important;
  color: #3a3c40;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.talentPoolcandidateToggle .unselOption:hover {
  background: #e8eff4;
}

.talentPoolcandidateToggle .selOption {
  font-weight: 600;
  font-family: var(--lato);
  font-size: 13px;
  padding: 8px !important;
  color: #3a3c40;
  background: #e8eff4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
}

.talentpool-thirdparty-unsel {
  color: var(--bluetheme);
  font-weight: var(--weight-M);
  font-family: var(--lato);
  font-size: var(--size-14);
  padding: 8px;
}

.talentpool-thirdparty-unsel:hover {
  background: #e8eff4;
  border-radius: 4px;
}

.talentpool-thirdparty-sel {
  color: var(--bluetheme);
  font-weight: var(--weight-M);
  font-family: var(--lato);
  font-size: var(--size-14);
  padding: 8px;
  background: #e8eff4;
  border-radius: 4px;
}

/* .talentPoolcandidateToggle > div:hover {
  background: #e8eff4;
  border-radius: 4px;
} */
.qb-filter-count {
  width: 7px;
  background: #eb0002;
  border-radius: 10px;
  border: 1px solid #ffffff;
  height: 7px;
  text-align: center;
  bottom: 0px;
  padding-top: 2px;
  position: absolute;
  margin-left: 19px;
}

.tp-modal-card {
  height: calc(100vh - 322px);
  overflow: auto;
}

.tp-sub-card {
  box-sizing: border-box;

  height: 87px;

  background: #fafafa;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 4px 12px rgba(196, 196, 196, 0.5);
  border-radius: 3px;
  padding: 10px;
}

.tp-sub-card-first {
  box-sizing: border-box;

  height: 87px;

  background: #e7e8f5;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 4px 12px rgba(196, 196, 196, 0.5);
  border-radius: 3px;
  padding: 10px;
}

.tp-text {
  font-size: 11px;
  font-weight: 400;
  color: #696969;
}

.tp-top-existcard {
  height: 10px;
  background: red;
  border-radius: 5px 5px 0px 0px;
}

.tp-top-card {
  height: 10px;
  background: #9dd49a;
  border-radius: 5px 5px 0px 0px;
}

.tp-side-modal-card {
  background: #eeeeee;
  border-radius: 5px;
}

.tp-side-modal-card-vendor {
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  height: calc(100vh - 305px);
}

.no-vend-selected {
  height: calc(100vh - 305px);
  overflow-x: hidden;
}

.tp-side-modal-card-1 {
  background: #eeeeee;
  border-radius: 5px;
}

.tp-side-modal-below-card {
  min-height: auto;
  max-height: calc(100vh - 597px);
  overflow: auto;
  background: #fbfbfb;
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
}

.tp-side-modal-below-card-2 {
  min-height: calc(100vh - 744px);
  background: #fbfbfb;
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
}

.tp-side-modal-below-card-3 {
  min-height: auto;
  max-height: calc(100vh - 595px);
  overflow: auto;
  background: #fbfbfb;
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
}

.tp-side-modal-below-card-vendor {
  min-height: auto;
  max-height: calc(100vh - 365px);
  overflow: auto;
  background: #fbfbfb;
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
}

.tp-modal-note {
  color: #8a8b8c;
  font-weight: 400;
  font-size: 14px;
}

.tp-below-text {
  font-size: 14px;
  font-weight: 400;
  color: #696969;
}

.tp-below-text-2 {
  font-size: 14px;
  font-weight: 400;
  color: #72738e;
}

.tp-card {
  font-size: 14px;
  font-weight: 600;
  color: #72738e;
}

.tp-card-head {
  font-size: 14px;
  font-weight: 600;
  color: #696969;
}

.talentpool-exportcard {
  position: absolute;
  top: 66px;
  right: 15px;
  background: var(--bg-white);
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
  border-radius: 5px;
  padding: 20px 15px;
  z-index: 7;
  font-size: var(--size-13);
  color: #545454;
}

.selected-table-cards:hover {
  background: #e7e8f5;
}

.disjdbtn .btn-secondary:disabled {
  color: #f7f7f7;
  background-color: #c4c4c4;
  border-color: transparent !important;
}

.sec-addquestext a {
  font-weight: var(--weight-LM);
  font-size: var(--size-13);

  text-decoration-line: underline;

  color: var(--bg-tertiary);
}

.jdclosecards {
  background: rgba(255, 255, 255, 0.75);
  border: 0.7px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  font-weight: 600;
  font-size: 14px;
  color: #72738e;
  padding: 15px 20px;
}

.qb-filter-modal {
  padding: 10px;
  background: #ffffff;
  border: 0.7px solid rgba(114, 115, 142, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  z-index: 6;
}

.aoeinput .form-control {
  padding: 0.375rem 1.3rem !important;
}

.check {
  overflow: auto;
  display: flex;
}

.checkrow:nth-child(odd) {
  background: #fdfdfd;
}

.checkrow:nth-child(even) {
  background: #a8a8a8;
}

.aoeinput .row {
  margin-right: 0px;
  margin-left: 0px;
  height: auto;
}

.fontclass {
  font-weight: 400;
  font-size: 14px;
  color: #545454;
}

.custom-design-main {
  position: relative;
}

.custom-design {
  background: #fdfdfd;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
}

.cust-dropdoen-menu {
  position: absolute;
  top: 56px;
  width: 100%;
  height: 165px;
  padding: 5px;
  overflow: auto;
}

.sec-addquestext {
  font-weight: var(--weight-LM);
  font-size: var(--size-13);
  text-decoration-line: underline;
  color: var(--bg-tertiary);
}

.onclickcolor {
  color: blue;
}

.flex-container {
  display: flex;
  flex-direction: row-reverse;
}

.talentpool-dates .startdatejd > input {
  height: 33px;
  padding: 1px 0.75rem;
  border-radius: 8px;
  border: 1px solid var(--gray-300, #d0d5dd);
  background: var(--base-white, var(--bg-white));
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #332d2d;
  font-size: var(--size-13);
  font-family: var(--montserrat);
  font-weight: var(--weight-LM);
  width: 97%;
}

.talentpool-dates .startdatejd::placeholder {
  font-family: var(--montserrat);
  font-size: var(--size-13);
  font-weight: var(--weight-R);
  color: #667085;
}

.tp-modal-pos {
  position: absolute;
  top: 2px;
  right: 18px;
}

.jd-text {
  display: block;
  width: 20px;
  word-wrap: break-word;
}

.tp-green-text {
  font-weight: 400;
  font-size: 11px;
  color: #038e00;
}

.tp-red-text {
  font-weight: 400;
  font-size: 11px;
  color: #ff4752;
}

.tp-second-right-overflow {
  height: calc(100vh - 220px);

  overflow: auto;
}

.tp-cust-back {
  background: #e7e8f5;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 4px 12px rgba(196, 196, 196, 0.5);
  border-radius: 3px;
}

.tp-cust-back-white {
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  padding: 2px 5px 11px 10px;
}

.tp-cust-name-overflow {
  min-height: auto;
  max-height: calc(100vh - 290px);
  overflow: auto;
}

.tp-odd-even-color:nth-child(odd) {
  background: #f4f4f4;
}

.tp-odd-even-color:nth-child(even) {
  background: #fdfdfd;
}

.tp-height {
  height: calc(100vh - 351px);
  overflow: auto;
}

.tp-height-vendor {
  height: calc(100vh - 268px);
  overflow: auto;
}

.search-novend {
  margin-top: 162px;
}

.tp-modal-overflow {
  overflow-y: auto;
  height: calc(100vh - 210px);
  overflow-x: hidden;
}

.tp-grey-checkbox .custom-control-label::before {
  background-color: #ffffff;
  border: 0.2px solid #adaaaa;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.34);
  border-radius: 2px;
}

/* new table design starts from here */
.talentPool-table-container {
  background: #ffffff;
  border-radius: 8px;
  /* padding: 15px; */
  /* No forced min-width: the card must fit the available width so neither the
     wrapper nor the page scrolls horizontally. The inner .talentPool-main-table
     is the single horizontal scroller. (The 1410px min-width, plus the wrapper's
     old overflow-x:auto, pushed the card past the viewport and produced a second
     horizontal scroll.) Also set inline on the element so a stale stylesheet
     can't reintroduce the min-width. */
  min-width: 0;
  max-width: 100%;
  height: calc(100vh - 165px);
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  overflow: auto;
  /* margin: 10px; */
}

.tp-table-container {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgb(196 196 196 / 50%);
  height: calc(100vh - 168px);
  /* padding: 15px; */
}

.talentPool-main-table {
  width: 100%;
  position: relative;
  /* Fill the remaining space in the flex card body; the pagination bar sits
     below this as a sibling so it stays pinned while only the rows scroll. */
  flex: 1 1 auto;
  min-height: 0;
  /* Single scroll container for BOTH axes: this lets the header stay sticky at
     the top and the Actions column stay pinned to the right while the rest of
     the table scrolls. (A separate overflow on the body would make the body its
     own horizontal scroll container and break the right-pinned column.)
     NOTE: the element's actual horizontal padding comes from the Bootstrap
     `pr-0 pl-0 py-0` utilities in the template (which win over this rule); the
     right padding is 0 so the pinned Actions column sits flush against the
     scroll edge and columns scrolling past are clipped there (no peek). */
  overflow: auto;
  padding: 0 15px;
}

.talentPool-admin-main-table {
  width: 100%;
  position: relative;
  /* Fill the remaining flex space; see .talentPool-main-table. */
  flex: 1 1 auto;
  min-height: 0;
  /* Single scroll container for both axes; see .talentPool-main-table. */
  overflow: auto;
  padding: 0 15px;
}

/* Card body is a flex column: header/toolbar (auto) + scrollable table (flex)
   + pagination bar (auto, pinned at the bottom of the card). */
.tp-card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* Pagination bar stays at the bottom of the card, outside the scroll area, so
   it is always visible while the rows scroll. */
.tp-pagination-bar {
  flex-shrink: 0;
  padding-top: 10px;
  padding-bottom: 8px;
  background: #ffffff;
  border-top: 1px solid rgba(32, 99, 155, 0.12);
}

.talentPool-main-table,
.talentPool-admin-main-table {
  overflow-x: auto;
}
.talentPool-table-head > div,
.talentPool-admin-table-head > div,
.talentPool-table-row > div {
  flex-shrink: 0;
}
.talentPool-table-head {
  /* subtract the mx-3 (2rem) horizontal margin so the header's margin-box fills —
     but does not overflow — the container when columns fit within the viewport. */
  min-width: calc(100% - 2rem);
  width: max-content;
  display: flex;
  align-items: center;
  padding: 10px 0px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: var(--bluetheme);
  font-family: var(--lato);
  /* Opaque equivalent of the previous rgba(32,99,155,0.1) tint over the white
     container, so rows scrolling underneath don't show through the sticky head. */
  background: #e9eff5;
  border-radius: 8px;
  /* Same border width as .talentPool-table-row (transparent here) so the
     header's cells start at exactly the same x as the row cells; without it the
     body columns sit 0.5px right of their headers. */
  border: 0.5px solid transparent;
  /* Keep the header visible while the container scrolls vertically. */
  position: sticky;
  top: 0;
  z-index: 5;
}

.talentPool-admin-table-head {
  /* subtract the mx-3 (2rem) horizontal margin so the header's margin-box fills —
     but does not overflow — the container when columns fit within the viewport. */
  min-width: calc(100% - 2rem);
  width: max-content;
  display: flex;
  align-items: center;
  padding: 10px 0px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: var(--bluetheme);
  font-family: var(--lato);
  /* Opaque equivalent of the previous rgba(32,99,155,0.1) tint; see above. */
  background: #e9eff5;
  border-radius: 8px;
  /* Mirror the row border width so header and row cells share the same x. */
  border: 0.5px solid transparent;
  position: sticky;
  top: 0;
  z-index: 5;
}

/* The outer container owns scrolling. Setting overflow here would make the
   body a scroll container and pin Actions to the body's edge instead of the
   viewport. */
.talentPool-table-body {
  min-width: 100%;
  width: max-content;
}

.talentPool-admin-table-body {
  min-width: 100%;
  width: max-content;
}

/* Empty / no-results state: fill the visible table area (width so the
   illustration and message center horizontally across the viewport rather than
   hugging the body's left origin; min-height so they sit vertically centred in
   the table instead of tucked at the top). Sits inside .talentPool-table-body,
   whose min-width:100% gives the 100% a definite floor. */
.tp-empty-state {
  width: 100%;
  min-height: calc(100vh - 320px);
}

/* "Clear filters" affordance in the no-results empty state. */
.tp-clear-filters {
  margin-top: 12px;
  padding: 6px 14px;
  border: 1px solid var(--bluetheme);
  border-radius: 6px;
  background: transparent;
  color: var(--bluetheme);
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.tp-clear-filters:hover {
  background: var(--bluetheme);
  color: #ffffff;
}

.talentPool-table-row {
  width: max-content;
  min-width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: var(--bluetheme);
  font-family: var(--lato);
  padding: 10px 0px;
  margin: 8px 0px;
  cursor: default;
}

.talentPool-table-row:hover {
  background: #e7e8f5;
}

/* Accessible By initials: the circles are absolutely positioned, so give their
   wrapper the circles' height; without it the wrapper (and the cell) collapse to
   0px and the cell's overflow:hidden clips the circles away (DE-5992). */
.tp-access-icons {
  height: 30px;
}

/* CVS status label (mirrors the workbench colors) */
.tp-cvs-status {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

/* Configurable columns.
   Symmetric horizontal padding keeps labels left-aligned while the right-edge
   divider sits centered in the gap between columns instead of hugging a label. */
.tp-config-col-head {
  flex: 1 0 auto;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 16px;
  padding-right: 16px;
}
.tp-config-col-body {
  flex: 1 0 auto;
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;
  /* Full row height with centred content, pinned or not, so pinned and
     scrolling cells lay their content out identically (see the pinned-cell
     rule below). */
  align-self: stretch;
  display: flex;
  align-items: center;
}

/* When the visible columns don't fill the viewport, let the data columns grow
   to absorb the leftover space (no empty gutter / less truncation). Their set
   px width acts as the flex-basis and as a floor: flex-shrink stays 0, so once
   the columns overflow the viewport they keep their width and the table scrolls
   horizontally instead of shrinking. Applied identically to the header and body
   data cells so the two stay column-aligned; the checkbox/source/actions cells
   are intentionally excluded and keep their fixed width. */
.tp-grow-col {
  flex: 1 0 auto;
}

/* Pin the Actions column to the right edge so it stays reachable regardless of
   how many columns are shown or how far the table is scrolled horizontally.
   right:0 keeps it flush with the scroll container's edge so columns scrolling
   past are clipped there (no strip to their right to peek through), and the
   opaque background masks the columns passing beneath it. */
.tp-actions-col {
  position: sticky;
  right: 0;
  z-index: 3;
  /* Soft drop shadow on the left edge, mirroring the left pinned block's
     `.tp-sticky-col-last` shadow so both sticky boundaries read the same
     (shadow points inward, toward the scrolling content on this column's left). */
  box-shadow: -6px 0 8px -6px rgba(0, 0, 0, 0.18);
}
.talentPool-table-head .tp-actions-col,
.talentPool-admin-table-head .tp-actions-col {
  /* Two-class selector so this wins over `.talentPool-table-head > div {
     position: relative }` (used to anchor the column dividers) which would
     otherwise override the sticky position and stop the header cell pinning. */
  position: sticky;
  right: 0;
  background: #e9eff5;
}
.talentPool-table-row .tp-actions-col {
  background: #fcfcfc;
}
/* While a row's action menu is open, lift its pinned cell above the other
   rows' pinned cells (all at z-index 3) so the dropdown isn't covered by the
   three-dot icons of the rows below it. Stays below the sticky header (5). */
.talentPool-table-row .tp-actions-col.tp-actions-col-open {
  z-index: 4;
}
.talentPool-table-row:hover .tp-actions-col {
  background: #e7e8f5;
}

/* Left-pinned columns: the always-pinned lead cells (checkbox + Source) and the
   first `stickyColCount` model columns stay in place while the rest scrolls,
   mirroring the right-pinned Actions column. The `left` offset is set inline as
   a running sum of the preceding pinned columns' widths. */
.tp-sticky-lead,
.tp-sticky-col {
  position: sticky;
  z-index: 3;
}
/* The pre-existing blue row accent bar sits behind the now-opaque pinned lead
   cells, which clipped it to a sliver. Lift it above the pinned cells (z 3) but
   keep it below the sticky header (z 5) so it renders as the full accent again. */
.talentPool-table-row .tp-gridgreencolorDynamic {
  z-index: 4;
}
/* Header cells: the two-class selector beats `.talentPool-table-head > div {
   position: relative }`; the opaque header background masks columns scrolling
   underneath. */
.talentPool-table-head .tp-sticky-lead,
.talentPool-table-head .tp-sticky-col,
.talentPool-admin-table-head .tp-sticky-lead,
.talentPool-admin-table-head .tp-sticky-col {
  position: sticky;
  background: #e9eff5;
  z-index: 2;
}
.talentPool-table-row .tp-sticky-lead,
.talentPool-table-row .tp-sticky-col {
  background: #fcfcfc;
}
/* Pinned body cells (lead cells + Actions here; the model columns via
   `.tp-config-col-body`) span the row's full content height with their
   content centred, so their opaque background masks every column scrolling
   beneath them. Otherwise each cell is only as tall as its content (the row
   centres its items), so rows with taller neighbours — or the 0-height Accessible
   By initials cell — let the scrolling columns' data show through (DE-5992).
   `position: sticky` is repeated here so the global `.relativeclass` on these
   cells can never win on load order. */
.talentPool-table-row .tp-sticky-lead,
.talentPool-table-row .tp-actions-col {
  position: sticky;
  align-self: stretch;
  display: flex;
  align-items: center;
}
.talentPool-table-row .tp-sticky-lead.text-center,
.talentPool-table-row .tp-actions-col {
  justify-content: center;
}
/* Keep the row action menu just below the (now vertically centred) kebab icon. */
.talentPool-table-row .tp-actions-col .kanban-more-option-card {
  top: calc(50% + 14px);
}
.talentPool-table-row:hover .tp-sticky-lead,
.talentPool-table-row:hover .tp-sticky-col {
  background: #e7e8f5;
}
/* Boundary between the pinned block and the scrolling columns: a soft shadow
   (not a hard border, which would collide with the header's ::after divider and
   read as a double, misaligned line). */
.tp-sticky-col-last {
  box-shadow: 6px 0 8px -6px rgba(0, 0, 0, 0.18);
}

/* Give every column left breathing room so the divider on its left edge doesn't
   hug the label. Applied to header and matching body cells so they stay aligned;
   the decorative left strip is excluded. */
.talentPool-table-head > div,
.talentPool-admin-table-head > div,
.talentPool-table-row > div:not(.tp-gridgreencolorDynamic) {
  padding-left: 16px;
}

/* Always-visible vertical divider on the right edge of every header column
   (both the fixed columns and the configurable ones). */
.talentPool-table-head > div,
.talentPool-admin-table-head > div {
  position: relative;
}
.talentPool-table-head > div:not(:last-child):not(.tp-no-divider)::after,
.talentPool-admin-table-head > div:not(:last-child):not(.tp-no-divider)::after {
  content: "";
  position: absolute;
  top: 15%;
  right: 0;
  height: 70%;
  width: 1px;
  background: rgba(32, 99, 155, 0.5);
  transition: background 0.15s ease;
}
/* Resizable columns: darken the divider on hover as an affordance. */
.tp-config-col-head:hover::after,
.tp-resizable-col:hover::after {
  background: var(--bluetheme);
}
/* Narrow resize grab strip hugging the divider, so the col-resize cursor only
   appears right over the divider (not several pixels early). */
.tp-col-resizer {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 6px;
  cursor: col-resize;
  user-select: none;
}

/* Column configuration popover (matches Figma) */
.tp-column-config-card {
  position: absolute;
  top: 30px;
  right: 0;
  width: 240px;
  max-height: 360px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f9f9f9;
  border: 1px solid rgba(41, 136, 230, 0.22);
  border-radius: 4px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.18);
  z-index: 6;
}
.tp-cfg-list {
  flex: 1 1 auto;
  overflow-y: auto;
  /* Keep the divider shake from showing a horizontal scrollbar. */
  overflow-x: hidden;
  /* Prevents selection auto-scroll while dragging near the list edge. */
  user-select: none;
}
/* Divider snap-back: shake, then slide (transition-group move). */
.tp-cfg-flip-move {
  transition: transform 0.35s ease;
}
.tp-cfg-shake {
  animation: tp-cfg-shake 0.4s ease;
}
@keyframes tp-cfg-shake {
  0%,
  100% {
    transform: translateX(0);
  }
  20%,
  60% {
    transform: translateX(-6px);
  }
  40%,
  80% {
    transform: translateX(6px);
  }
}
/* "Available columns" heading above the hidden (alphabetical) columns. */
.tp-cfg-section-label {
  padding: 10px 8px 4px;
  border-top: 1px solid rgba(41, 136, 230, 0.18);
  font-family: "Lato", sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--bluetheme);
}
/* Hidden rows have no drag handle; indent so labels line up with the shown
   rows (24px handle + 8px gap). */
.tp-cfg-section-label ~ .tp-cfg-row .tp-cfg-label {
  padding-left: 32px;
}
.tp-cfg-footer {
  flex: 0 0 auto;
  border-top: 1px solid rgba(41, 136, 230, 0.18);
  padding: 8px;
  text-align: center;
  background: #f9f9f9;
}
.tp-cfg-reset {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: var(--bluetheme);
}
.tp-cfg-row {
  padding: 4px 8px;
  background: #f9f9f9;
}
/* Draggable divider between the pinned (above) and scrolling (below) columns. */
.tp-cfg-divider-row {
  padding: 6px 8px;
  cursor: grab;
  background: #f9f9f9;
}
.tp-cfg-divider-line {
  flex: 1 1 auto;
  height: 2px;
  border-radius: 2px;
  background: var(--bluetheme);
  margin-right: 8px;
}
.tp-cfg-divider-label {
  flex: 0 0 auto;
  font-family: "Lato", sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--bluetheme);
}
.tp-cfg-left {
  min-width: 0;
}
.tp-cfg-drag {
  width: 24px;
  height: 24px;
  cursor: move;
  flex: 0 0 auto;
}
.tp-cfg-label {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #3a3c40;
}
.tp-cfg-toggle {
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
}
/* Locked default columns: shown as on but not clickable. */
.tp-cfg-toggle-locked {
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  opacity: 0.45;
  cursor: not-allowed;
}
.tp-cfg-row.sortable-ghost {
  opacity: 0.4;
}
/* Row following the pointer while dragging (Sortable fallback mode). */
.tp-cfg-item.sortable-drag {
  opacity: 0.9 !important;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
}

.candidate-status-font {
  color: #545454;
  font-size: 12px;
  font-weight: 500;
}

.choose-source-class {
  font-weight: 400;
  font-size: 14px;
  color: #667085;
  font-family: var(--montserrat);
}

.export-loader-pos {
  position: absolute;
  top: -50px;
  z-index: 1;
  left: -2px;
}

.export-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 90px;
}

.tp-new-thirdparty-drop {
  position: absolute;
  font-weight: 600;
  font-family: var(--lato);
  font-size: 13px;
  color: #3a3c40;
  left: -250px;
  top: 7px;
  background: #f9f9f9;
  padding: 10px;
  z-index: 3;
  width: 240px !important;
  border-radius: 4px;
  box-shadow: 0px 6px 11px 0px #00000047;
}

.tp-new-thirdparty-drop:hover {
  background: #e8eff4;
}
.bookmark-blue-container {
  padding: 12px;
  background: linear-gradient(
      0deg,
      rgba(32, 99, 155, 0.14),
      rgba(32, 99, 155, 0.14)
    ),
    #ffffff;
  border-radius: 8px;
}
.bookmark-folder-content-height {
  padding: 0px 8px 0px 8px;
  min-height: auto;
  max-height: 350px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
